import { jsxs as Ze, jsx as z } from "react/jsx-runtime";
import rt, { useState as _r, useEffect as Fr, useRef as xn, useDebugValue as Wt, useContext as Ft, createElement as Nn } from "react";
var zt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Bn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var _e = {},
  Mr;
Object.defineProperty(_e, "__esModule", {
  value: !0
});
var Cr = 320,
  Re = 576,
  Pe = 768,
  Ye = 992,
  Le = 1200,
  ut = {
    SIZE_XS: Cr,
    SIZE_SM: Re,
    SIZE_MD: Pe,
    SIZE_LG: Ye,
    SIZE_XL: Le
  },
  Rn = {
    mobile: "(min-width: " + Cr + "px)",
    mobileL: "(min-width: " + Re + "px)",
    tablet: "(min-width: " + Pe + "px)",
    tabletL: "(min-width: " + Ye + "px)",
    desktop: "(min-width: " + Le + "px)"
  },
  Pn = {
    mobile: "(max-width: " + (Re - 1) + "px)",
    mobileL: "(max-width: " + (Pe - 1) + "px)",
    tablet: "(max-width: " + (Ye - 1) + "px)",
    tabletL: "(max-width: " + (Le - 1) + "px)"
  },
  Yn = {
    mobile: "(max-width: " + Re + "px)",
    mobileL: "(min-width: " + Re + "px) and (max-width: " + (Pe - 1) + "px)",
    tablet: "(min-width: " + Pe + "px) and (max-width: " + (Ye - 1) + "px)",
    tabletL: "(min-width: " + Ye + "px) and (max-width: " + (Le - 1) + "px)",
    desktop: "(min-width: " + Le + "px)"
  },
  Ln = {
    device: Rn,
    deviceDown: Pn,
    deviceOnly: Yn
  },
  Mt = {
    AeroBlue: "#c6eada",
    AzureX: "#e6f7fb",
    AzureXDark: "#0a1f26",
    BabyPink: "#f8c9c5",
    Black: "#000000",
    BlackTransparent: "rgba(0,0,0,0.7)",
    BlackTransparentLight: "rgba(0,0,0,0.2)",
    BlackTransparentMedium: "rgba(0,0,0,0.35)",
    BlizzardBlue: "#b3e8f4",
    BlueCloudy: "#a7bdcc",
    BlueCloudyTransparent: "rgba(167,189,204,0.5)",
    BlueDark: "#2c3b45",
    BlueDarkGradient: "linear-gradient(-225deg, rgb(44, 59, 69) 0%, rgb(78, 98, 110) 100%)",
    BlueDawn: "#007f9e",
    BlueFog: "#CEDAE1",
    BlueHeaven: "#64dfff",
    BlueLight: "#E4EBEF",
    BlueLightGradient: "linear-gradient(-225deg, rgb(235, 249, 252) 0%, rgb(191, 240, 247) 100%)",
    BlueMoon: "#3c5463",
    BlueNight: "#1D6478",
    BlueSky: "#00b3db",
    BlueSkyVivid: "#33c2e2",
    BlueSmoke: "#F1F5F7",
    Bittersweet: "#ed7064",
    Bunker: "#171E24",
    DeepChampagne: "#fbd38d",
    GreenDark: "#19a568",
    GreenFlash: "#44DB5E",
    GreenGarden: "#029231",
    GreenLight: "#52cb95",
    GreenMedium: "#1AAF5D",
    GreenOcean: "#67c89d",
    GreenSeafoam: "#41ba84",
    Grey: "#e6e8e9",
    GreyBackground: "#ebf0f2",
    GreyBlue: "#5A7A8E",
    GreyBright: "#f7f7f7",
    GreyDark: "#5e6467",
    GreyLight: "#d8d8d8",
    GreyMedium: "#b7b7b7",
    GreyWarm: "#959da2",
    GreyWhite: "#efefef",
    HoneyDew: "#d9f1e6",
    HoneyDewDark: "#153127",
    LavenderBlush: "#fdedec",
    LavenderBlushDark: "#201516",
    LightCyan: "#ccf0f8",
    LightCyanDark: "#07313A",
    MagicMint: "#b3e3ce",
    Melon: "#f6b7b1",
    MintCream: "#ecf8f3",
    MintCreamDark: "#10201D",
    MistyRose: "#fadbd8",
    MistyRoseDark: "#361B1A",
    NonPhotoBlue: "#99e1f1",
    OldLace: "#fef6e8",
    OldLaceDark: "#221E13",
    Orange: "#f7a71a",
    OrangeDark: "#ff860f",
    PapayaWhip: "#fdedd1",
    PapayaWhipDark: "#392D13",
    Peach: "#fde5da",
    Purple: "#b90059",
    Sunary: "#f9c15f",
    Tomato: "#e84c3d",
    TomatoDark: "#ca4036",
    TomatoLight: "#eb8b84",
    TomatoFlash: "#CB1212",
    Transparent: "transparent",
    VisaGold: "#a18950",
    VisaPlatinum: "#86898b",
    White: "#ffffff",
    WhiteTransparent: "rgba(255,255,255,0.3)",
    YellowVanilla: "#fbf4d3",
    Grey10Ghost: "#F7F9FA",
    Grey20Smoke: "#F2F5F7",
    Grey30Mist: "#E6EDF0",
    Grey40Haze: "#DAE3E8",
    Grey50Fog: "#CEDAE0",
    Grey60Smog: "#BAC8CF",
    Grey70Cloudy: "#A9BAC4",
    Grey80Concrete: "#A0B1BA",
    Grey90Silver: "#94A7B0",
    Grey100Steel: "#889CA6",
    Grey200Slate: "#7C919C",
    Grey300Lead: "#7C919C",
    Grey400Iron: "#677C87",
    Grey500Titanium: "#5C727D",
    Grey600Graphite: "#536673",
    Grey700Obsidian: "#495C69",
    Grey800Darkblue: "#2C3B45",
    Grey850Shadow: "#24323C",
    Grey900Night: "#1E2A33",
    Grey950Pitchdark: "#172026",
    Grey1000Black: "#000000",
    Red100: "#FAE9E7",
    Red200: "#F6D2CE",
    Red300: "#EDA59D",
    Red400: "#E3786D",
    Red500: "#DA4B3C",
    Red600: "#D11E0B",
    Red700: "#A71809",
    Red800: "#7D1207",
    Orange100: "#FEF6E8",
    Orange200: "#FDEDD1",
    Orange300: "#FCDCA3",
    Orange400: "#FACA76",
    Orange500: "#F9B948",
    Orange600: "#F7A71A",
    Orange700: "#DE9617",
    Orange800: "#C68615",
    Orange900: "#8A6628",
    Green100: "#E6F3EE",
    Green200: "#CDE8DE",
    Green300: "#9AD0BD",
    Green400: "#35A17A",
    Green500: "#1C9166",
    Green600: "#038153",
    Green700: "#026E47",
    Green800: "#025335",
    Blue100: "#E6F7FB",
    Blue200: "#CCF0F8",
    Blue300: "#B3E8F4",
    Blue400: "#99E1F1",
    Blue500: "#33C2E2",
    Blue600Sky: "#00B3DB",
    Blue700Dawn: "#007F9E",
    Blue800: "#006480"
  },
  Gn = function (e) {
    if (Mt[e] === void 0) throw new Error("Unknown color " + e);
    return !0;
  },
  $n = function (r, t) {
    Gn(r);
    var r = Mt[r];
    return 7 < r.length || r.substr(0, 1) !== "#" ? null : (r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(r), "rgba(" + parseInt(r[1], 16) + ", " + parseInt(r[2], 16) + ", " + parseInt(r[3], 16) + ", " + (t || 0) + ")");
  },
  Hn = {
    hexToTransparentRGBA: $n,
    list: Mt
  },
  Ir = {
    af: {
      phone: "+93",
      isSepa: !1
    },
    ax: {
      phone: "+358",
      isSepa: !1
    },
    al: {
      phone: "+355",
      isSepa: !1
    },
    dz: {
      phone: "+213",
      isSepa: !1
    },
    as: {
      phone: "+1684",
      isSepa: !1
    },
    ad: {
      phone: "+376",
      isSepa: !0
    },
    ao: {
      phone: "+244",
      isSepa: !1
    },
    ai: {
      phone: "+1264",
      isSepa: !1
    },
    aq: {
      phone: "+672",
      isSepa: !1
    },
    ag: {
      phone: "+1268",
      isSepa: !1
    },
    ar: {
      phone: "+54",
      isSepa: !1
    },
    am: {
      phone: "+374",
      isSepa: !1
    },
    aw: {
      phone: "+297",
      isSepa: !1
    },
    au: {
      phone: "+61",
      isSepa: !1
    },
    at: {
      phone: "+43",
      isSepa: !0
    },
    az: {
      phone: "+994",
      isSepa: !1
    },
    bs: {
      phone: "+1242",
      isSepa: !1
    },
    bh: {
      phone: "+973",
      isSepa: !1
    },
    bd: {
      phone: "+880",
      isSepa: !1
    },
    bb: {
      phone: "+1246",
      isSepa: !1
    },
    by: {
      phone: "+375",
      isSepa: !1
    },
    be: {
      phone: "+32",
      isSepa: !0
    },
    bz: {
      phone: "+501",
      isSepa: !1
    },
    bj: {
      phone: "+229",
      isSepa: !1
    },
    bm: {
      phone: "+1441",
      isSepa: !1
    },
    bt: {
      phone: "+975",
      isSepa: !1
    },
    bo: {
      phone: "+591",
      isSepa: !1
    },
    ba: {
      phone: "+387",
      isSepa: !1
    },
    bw: {
      phone: "+267",
      isSepa: !1
    },
    bv: {
      phone: "+47",
      isSepa: !1
    },
    br: {
      phone: "+55",
      isSepa: !1
    },
    io: {
      phone: "+246",
      isSepa: !1
    },
    bn: {
      phone: "+673",
      isSepa: !1
    },
    bg: {
      phone: "+359",
      isSepa: !0
    },
    bf: {
      phone: "+226",
      isSepa: !1
    },
    bi: {
      phone: "+257",
      isSepa: !1
    },
    kh: {
      phone: "+855",
      isSepa: !1
    },
    cm: {
      phone: "+237",
      isSepa: !1
    },
    ca: {
      phone: "+1",
      isSepa: !1
    },
    cv: {
      phone: "+238",
      isSepa: !1
    },
    ky: {
      phone: "+345",
      isSepa: !1
    },
    cf: {
      phone: "+236",
      isSepa: !1
    },
    td: {
      phone: "+235",
      isSepa: !1
    },
    cl: {
      phone: "+56",
      isSepa: !1
    },
    cn: {
      phone: "+86",
      isSepa: !1
    },
    cx: {
      phone: "+61",
      isSepa: !1
    },
    cc: {
      phone: "+61",
      isSepa: !1
    },
    co: {
      phone: "+57",
      isSepa: !1
    },
    km: {
      phone: "+269",
      isSepa: !1
    },
    cg: {
      phone: "+242",
      isSepa: !1
    },
    cd: {
      phone: "+243",
      isSepa: !1
    },
    ck: {
      phone: "+682",
      isSepa: !1
    },
    cr: {
      phone: "+506",
      isSepa: !1
    },
    ci: {
      phone: "+225",
      isSepa: !1
    },
    hr: {
      phone: "+385",
      isSepa: !0
    },
    cu: {
      phone: "+53",
      isSepa: !1
    },
    cy: {
      phone: "+357",
      isSepa: !0
    },
    cz: {
      phone: "+420",
      isSepa: !0
    },
    dk: {
      phone: "+45",
      isSepa: !0
    },
    dj: {
      phone: "+253",
      isSepa: !1
    },
    dm: {
      phone: "+1767",
      isSepa: !1
    },
    do: {
      phone: "+1849",
      isSepa: !1
    },
    ec: {
      phone: "+593",
      isSepa: !1
    },
    eg: {
      phone: "+20",
      isSepa: !1
    },
    sv: {
      phone: "+503",
      isSepa: !1
    },
    gq: {
      phone: "+240",
      isSepa: !1
    },
    er: {
      phone: "+291",
      isSepa: !1
    },
    ee: {
      phone: "+372",
      isSepa: !0
    },
    et: {
      phone: "+251",
      isSepa: !1
    },
    fk: {
      phone: "+500",
      isSepa: !1
    },
    fo: {
      phone: "+298",
      isSepa: !1
    },
    fj: {
      phone: "+679",
      isSepa: !1
    },
    fi: {
      phone: "+358",
      isSepa: !0
    },
    fr: {
      phone: "+33",
      isSepa: !0
    },
    gf: {
      phone: "+594",
      isSepa: !1
    },
    pf: {
      phone: "+689",
      isSepa: !1
    },
    tf: {
      phone: "+262",
      isSepa: !1
    },
    ga: {
      phone: "+241",
      isSepa: !1
    },
    gm: {
      phone: "+220",
      isSepa: !1
    },
    ge: {
      phone: "+995",
      isSepa: !1
    },
    de: {
      phone: "+49",
      isSepa: !0
    },
    gh: {
      phone: "+233",
      isSepa: !1
    },
    gi: {
      phone: "+350",
      isSepa: !0
    },
    gr: {
      phone: "+30",
      isSepa: !0
    },
    gl: {
      phone: "+299",
      isSepa: !1
    },
    gd: {
      phone: "+1473",
      isSepa: !1
    },
    gp: {
      phone: "+590",
      isSepa: !1
    },
    gu: {
      phone: "+1671",
      isSepa: !1
    },
    gt: {
      phone: "+502",
      isSepa: !1
    },
    gg: {
      phone: "+44",
      isSepa: !1
    },
    gn: {
      phone: "+224",
      isSepa: !1
    },
    gw: {
      phone: "+245",
      isSepa: !1
    },
    gy: {
      phone: "+592",
      isSepa: !1
    },
    ht: {
      phone: "+509",
      isSepa: !1
    },
    hm: {
      phone: "+0",
      isSepa: !1
    },
    hn: {
      phone: "+504",
      isSepa: !1
    },
    hk: {
      phone: "+852",
      isSepa: !1
    },
    hu: {
      phone: "+36",
      isSepa: !0
    },
    is: {
      phone: "+354",
      isSepa: !0
    },
    in: {
      phone: "+91",
      isSepa: !1
    },
    id: {
      phone: "+62",
      isSepa: !1
    },
    ir: {
      phone: "+98",
      isSepa: !1
    },
    iq: {
      phone: "+964",
      isSepa: !1
    },
    ie: {
      phone: "+353",
      isSepa: !0
    },
    im: {
      phone: "+44",
      isSepa: !1
    },
    il: {
      phone: "+972",
      isSepa: !1
    },
    it: {
      phone: "+39",
      isSepa: !0
    },
    jm: {
      phone: "+1876",
      isSepa: !1
    },
    jp: {
      phone: "+81",
      isSepa: !1
    },
    je: {
      phone: "+44",
      isSepa: !1
    },
    jo: {
      phone: "+962",
      isSepa: !1
    },
    kz: {
      phone: "+7",
      isSepa: !1
    },
    ke: {
      phone: "+254",
      isSepa: !1
    },
    ki: {
      phone: "+686",
      isSepa: !1
    },
    kp: {
      phone: "+850",
      isSepa: !1
    },
    kr: {
      phone: "+82",
      isSepa: !1
    },
    xk: {
      phone: "+383",
      isSepa: !1
    },
    kw: {
      phone: "+965",
      isSepa: !1
    },
    kg: {
      phone: "+996",
      isSepa: !1
    },
    la: {
      phone: "+856",
      isSepa: !1
    },
    lv: {
      phone: "+371",
      isSepa: !0
    },
    lb: {
      phone: "+961",
      isSepa: !1
    },
    ls: {
      phone: "+266",
      isSepa: !1
    },
    lr: {
      phone: "+231",
      isSepa: !1
    },
    ly: {
      phone: "+218",
      isSepa: !1
    },
    li: {
      phone: "+423",
      isSepa: !0
    },
    lt: {
      phone: "+370",
      isSepa: !0
    },
    lu: {
      phone: "+352",
      isSepa: !0
    },
    mo: {
      phone: "+853",
      isSepa: !1
    },
    mk: {
      phone: "+389",
      isSepa: !1
    },
    mg: {
      phone: "+261",
      isSepa: !1
    },
    mw: {
      phone: "+265",
      isSepa: !1
    },
    my: {
      phone: "+60",
      isSepa: !1
    },
    mv: {
      phone: "+960",
      isSepa: !1
    },
    ml: {
      phone: "+223",
      isSepa: !1
    },
    mt: {
      phone: "+356",
      isSepa: !0
    },
    mh: {
      phone: "+692",
      isSepa: !1
    },
    mq: {
      phone: "+596",
      isSepa: !1
    },
    mr: {
      phone: "+222",
      isSepa: !1
    },
    mu: {
      phone: "+230",
      isSepa: !1
    },
    yt: {
      phone: "+262",
      isSepa: !1
    },
    mx: {
      phone: "+52",
      isSepa: !1
    },
    fm: {
      phone: "+691",
      isSepa: !1
    },
    md: {
      phone: "+373",
      isSepa: !1
    },
    mc: {
      phone: "+377",
      isSepa: !0
    },
    mn: {
      phone: "+976",
      isSepa: !1
    },
    me: {
      phone: "+382",
      isSepa: !1
    },
    ms: {
      phone: "+1664",
      isSepa: !1
    },
    ma: {
      phone: "+212",
      isSepa: !1
    },
    mz: {
      phone: "+258",
      isSepa: !1
    },
    mm: {
      phone: "+95",
      isSepa: !1
    },
    na: {
      phone: "+264",
      isSepa: !1
    },
    nr: {
      phone: "+674",
      isSepa: !1
    },
    np: {
      phone: "+977",
      isSepa: !1
    },
    nl: {
      phone: "+31",
      isSepa: !0
    },
    nc: {
      phone: "+687",
      isSepa: !1
    },
    nz: {
      phone: "+64",
      isSepa: !1
    },
    ni: {
      phone: "+505",
      isSepa: !1
    },
    ne: {
      phone: "+227",
      isSepa: !1
    },
    ng: {
      phone: "+234",
      isSepa: !1
    },
    nu: {
      phone: "+683",
      isSepa: !1
    },
    nf: {
      phone: "+672",
      isSepa: !1
    },
    mp: {
      phone: "+1670",
      isSepa: !1
    },
    no: {
      phone: "+47",
      isSepa: !0
    },
    om: {
      phone: "+968",
      isSepa: !1
    },
    pk: {
      phone: "+92",
      isSepa: !1
    },
    pw: {
      phone: "+680",
      isSepa: !1
    },
    ps: {
      phone: "+970",
      isSepa: !1
    },
    pa: {
      phone: "+507",
      isSepa: !1
    },
    pg: {
      phone: "+675",
      isSepa: !1
    },
    py: {
      phone: "+595",
      isSepa: !1
    },
    pe: {
      phone: "+51",
      isSepa: !1
    },
    ph: {
      phone: "+63",
      isSepa: !1
    },
    pn: {
      phone: "+64",
      isSepa: !1
    },
    pl: {
      phone: "+48",
      isSepa: !0
    },
    pt: {
      phone: "+351",
      isSepa: !0
    },
    pr: {
      phone: "+1939",
      isSepa: !1
    },
    qa: {
      phone: "+974",
      isSepa: !1
    },
    ro: {
      phone: "+40",
      isSepa: !0
    },
    ru: {
      phone: "+7",
      isSepa: !1
    },
    rw: {
      phone: "+250",
      isSepa: !1
    },
    re: {
      phone: "+262",
      isSepa: !1
    },
    bl: {
      phone: "+590",
      isSepa: !1
    },
    sh: {
      phone: "+290",
      isSepa: !1
    },
    kn: {
      phone: "+1869",
      isSepa: !1
    },
    lc: {
      phone: "+1758",
      isSepa: !1
    },
    mf: {
      phone: "+590",
      isSepa: !1
    },
    pm: {
      phone: "+508",
      isSepa: !1
    },
    vc: {
      phone: "+1784",
      isSepa: !1
    },
    ws: {
      phone: "+685",
      isSepa: !1
    },
    sm: {
      phone: "+378",
      isSepa: !0
    },
    st: {
      phone: "+239",
      isSepa: !1
    },
    sa: {
      phone: "+966",
      isSepa: !1
    },
    sn: {
      phone: "+221",
      isSepa: !1
    },
    rs: {
      phone: "+381",
      isSepa: !1
    },
    sc: {
      phone: "+248",
      isSepa: !1
    },
    sl: {
      phone: "+232",
      isSepa: !1
    },
    sg: {
      phone: "+65",
      isSepa: !1
    },
    sk: {
      phone: "+421",
      isSepa: !0
    },
    si: {
      phone: "+386",
      isSepa: !0
    },
    sb: {
      phone: "+677",
      isSepa: !1
    },
    so: {
      phone: "+252",
      isSepa: !1
    },
    za: {
      phone: "+27",
      isSepa: !1
    },
    ss: {
      phone: "+211",
      isSepa: !1
    },
    gs: {
      phone: "+500",
      isSepa: !1
    },
    es: {
      phone: "+34",
      isSepa: !0
    },
    lk: {
      phone: "+94",
      isSepa: !1
    },
    sd: {
      phone: "+249",
      isSepa: !1
    },
    sr: {
      phone: "+597",
      isSepa: !1
    },
    sj: {
      phone: "+47",
      isSepa: !1
    },
    sz: {
      phone: "+268",
      isSepa: !1
    },
    se: {
      phone: "+46",
      isSepa: !0
    },
    ch: {
      phone: "+41",
      isSepa: !0
    },
    sy: {
      phone: "+963",
      isSepa: !1
    },
    tw: {
      phone: "+886",
      isSepa: !1
    },
    tj: {
      phone: "+992",
      isSepa: !1
    },
    tz: {
      phone: "+255",
      isSepa: !1
    },
    th: {
      phone: "+66",
      isSepa: !1
    },
    tl: {
      phone: "+670",
      isSepa: !1
    },
    tg: {
      phone: "+228",
      isSepa: !1
    },
    tk: {
      phone: "+690",
      isSepa: !1
    },
    to: {
      phone: "+676",
      isSepa: !1
    },
    tt: {
      phone: "+1868",
      isSepa: !1
    },
    tn: {
      phone: "+216",
      isSepa: !1
    },
    tr: {
      phone: "+90",
      isSepa: !1
    },
    tm: {
      phone: "+993",
      isSepa: !1
    },
    tc: {
      phone: "+1649",
      isSepa: !1
    },
    tv: {
      phone: "+688",
      isSepa: !1
    },
    ug: {
      phone: "+256",
      isSepa: !1
    },
    ua: {
      phone: "+380",
      isSepa: !1
    },
    ae: {
      phone: "+971",
      isSepa: !1
    },
    gb: {
      phone: "+44",
      isSepa: !0
    },
    us: {
      phone: "+1",
      isSepa: !1
    },
    uy: {
      phone: "+598",
      isSepa: !1
    },
    uz: {
      phone: "+998",
      isSepa: !1
    },
    va: {
      phone: "+379",
      isSepa: !0
    },
    vu: {
      phone: "+678",
      isSepa: !1
    },
    ve: {
      phone: "+58",
      isSepa: !1
    },
    vn: {
      phone: "+84",
      isSepa: !1
    },
    vg: {
      phone: "+1284",
      isSepa: !1
    },
    vi: {
      phone: "+1340",
      isSepa: !1
    },
    wf: {
      phone: "+681",
      isSepa: !1
    },
    ye: {
      phone: "+967",
      isSepa: !1
    },
    zm: {
      phone: "+260",
      isSepa: !1
    },
    zw: {
      phone: "+263",
      isSepa: !1
    }
  },
  Un = Object.keys(Ir),
  Or = {
    isoList: Un,
    list: Ir
  },
  Wn = {
    EUR: {
      value: "EUR",
      isDefault: !0,
      exceptions: [],
      moneyWire: !0,
      conversion: !0
    },
    AUD: {
      value: "AUD",
      isDefault: !1,
      exceptions: ["AU"],
      moneyWire: !0,
      conversions: !0
    },
    CAD: {
      value: "CAD",
      isDefault: !1,
      exceptions: ["CA"],
      moneyWire: !0,
      conversion: !0
    },
    CHF: {
      value: "CHF",
      isDefault: !1,
      exceptions: ["CH", "LI"],
      moneyWire: !0,
      conversion: !0
    },
    DKK: {
      value: "DKK",
      isDefault: !1,
      exceptions: ["DK"],
      moneyWire: !0,
      conversion: !0
    },
    GBP: {
      value: "GBP",
      isDefault: !1,
      exceptions: ["GB"],
      moneyWire: !0,
      conversion: !0
    },
    HUF: {
      value: "HUF",
      isDefault: !1,
      exceptions: [],
      moneyWire: !1,
      conversion: !0
    },
    JPY: {
      value: "JPY",
      isDefault: !1,
      exceptions: [],
      moneyWire: !1,
      conversion: !0
    },
    NOK: {
      value: "NOK",
      isDefault: !1,
      exceptions: ["NO"],
      moneyWire: !0,
      conversion: !0
    },
    NZD: {
      value: "NZD",
      isDefault: !1,
      exceptions: ["NZ"],
      moneyWire: !0,
      conversion: !0
    },
    SEK: {
      value: "SEK",
      isDefault: !1,
      exceptions: ["SE"],
      moneyWire: !0,
      conversion: !0
    },
    USD: {
      value: "USD",
      isDefault: !0,
      exceptions: [],
      moneyWire: !0,
      conversion: !0
    },
    ZAR: {
      value: "ZAR",
      isDefault: !1,
      exceptions: ["ZA", "NA"],
      moneyWire: !0,
      conversion: !0
    },
    TRY: {
      value: "TRY",
      isDefault: !1,
      exceptions: [],
      moneyWire: !1,
      conversion: !0
    }
  },
  zn = {
    list: Wn
  },
  jn = {
    bold: '"OpenSans Bold",sans-serif',
    extraBold: '"OpenSans ExtraBold",sans-serif',
    light: '"OpenSans Light",sans-serif',
    regular: '"OpenSans",sans-serif',
    semiBold: '"OpenSans SemiBold",sans-serif',
    boldItalic: '"OpenSans BoldItalic",sans-serif',
    regularItalic: '"OpenSans Italic",sans-serif',
    semiBoldItalic: '"OpenSans SemiBoldItalic",sans-serif',
    avertaBold: '"Averta Bold",sans-serif',
    avertaExtraBold: '"Averta ExtraBold",sans-serif',
    avertaLight: '"Averta Light",sans-serif',
    avertaRegular: '"Averta",sans-serif',
    avertaSemiBold: '"Averta SemiBold",sans-serif',
    avertaBoldItalic: '"Averta BoldItalic",sans-serif',
    avertaRegularItalic: '"Averta Italic",sans-serif',
    avertaSemiBoldItalic: '"Averta SemiBoldItalic",sans-serif'
  },
  Vn = function (e, t) {
    return (e.fonts && e.fonts[t] ? e.fonts : jn)[t];
  },
  Xn = {
    getFont: Vn
  },
  Zn = {
    mobile: {
      xs: "1.0rem",
      sm: "1.2rem",
      md: "1.4rem",
      df: "1.6rem",
      lg: "1.8rem",
      xl: "2.0rem",
      gt: "2.4rem",
      xg: "3.0rem"
    },
    mobileTitle: {
      xs: "1.8rem",
      sm: "2.3rem",
      md: "3.0rem",
      df: "3.3rem",
      lg: "4.0rem",
      xl: "4.8rem",
      gt: "5.2rem",
      xg: "5.6rem"
    },
    tablet: {
      xs: "1.0rem",
      sm: "1.2rem",
      md: "1.4rem",
      df: "1.6rem",
      lg: "1.8rem",
      xl: "2.0rem",
      gt: "2.4rem",
      xg: "3.0rem"
    },
    tabletTitle: {
      xs: "1.8rem",
      sm: "2.3rem",
      md: "3.0rem",
      df: "3.3rem",
      lg: "4.0rem",
      xl: "4.8rem",
      gt: "5.2rem",
      xg: "5.6rem"
    },
    desktop: {
      xs: "1.0rem",
      sm: "1.2rem",
      md: "1.4rem",
      df: "1.6rem",
      lg: "1.8rem",
      xl: "2.0rem",
      gt: "3.0rem",
      xg: "5.0rem"
    },
    desktopTitle: {
      xs: "2.0rem",
      sm: "2.6rem",
      md: "3.0rem",
      df: "3.6rem",
      lg: "4.2rem",
      xl: "5.0rem",
      gt: "6.0rem",
      xg: "7.0rem"
    }
  },
  Kn = {
    zero: "0",
    xs: "0.5rem",
    sm: "1rem",
    md: "2rem",
    lg: "3rem",
    xl: "4rem",
    gt: "5rem",
    xg: "6rem",
    auto: "auto"
  },
  kr = {
    breakpoints: Ln,
    colors: Hn,
    countries: Or,
    currencies: zn,
    fonts: Xn,
    fontSizes: Zn,
    spacings: Kn
  },
  Qn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof zt < "u" ? zt : typeof self < "u" ? self : {};
function qn(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}
var Ge = qn(function (e, t) {
    var r, n;
    r = Qn, n = function (a) {
      Array.prototype.map || (Array.prototype.map = function (u) {
        if (this == null) throw new TypeError();
        var v = Object(this),
          y = v.length >>> 0;
        if (typeof u != "function") throw new TypeError();
        for (var M = new Array(y), D = 2 <= arguments.length ? arguments[1] : void 0, h = 0; h < y; h++) h in v && (M[h] = u.call(D, v[h], h, v));
        return M;
      });
      var o = 65,
        i = 90;
      function d(u) {
        return (u = (u = u.toUpperCase()).substr(4) + u.substr(0, 4)).split("").map(function (v) {
          var y = v.charCodeAt(0);
          return o <= y && y <= i ? y - o + 10 : v;
        }).join("");
      }
      function m(u) {
        for (var v, y = u; 2 < y.length;) v = y.slice(0, 9), y = parseInt(v, 10) % 97 + y.slice(v.length);
        return parseInt(y, 10) % 97;
      }
      function f(u) {
        return u.replace(x, "").toUpperCase();
      }
      function s(u, v, y, M) {
        this.countryCode = u, this.length = v, this.structure = y, this.example = M;
      }
      s.prototype._regex = function () {
        return this._cachedRegex || (this._cachedRegex = (u = (u = this.structure).match(/(.{3})/g).map(function (D) {
          var y,
            M = D.slice(0, 1),
            D = parseInt(D.slice(1), 10);
          switch (M) {
            case "A":
              y = "0-9A-Za-z";
              break;
            case "B":
              y = "0-9A-Z";
              break;
            case "C":
              y = "A-Za-z";
              break;
            case "F":
              y = "0-9";
              break;
            case "L":
              y = "a-z";
              break;
            case "U":
              y = "A-Z";
              break;
            case "W":
              y = "0-9a-z";
          }
          return "([" + y + "]{" + D + "})";
        }), new RegExp("^" + u.join("") + "$")));
        var u;
      }, s.prototype.isValid = function (u) {
        return this.length == u.length && this.countryCode === u.slice(0, 2) && this._regex().test(u.slice(4)) && m(d(u)) == 1;
      }, s.prototype.toBBAN = function (u, v) {
        return this._regex().exec(u.slice(4)).slice(1).join(v);
      }, s.prototype.fromBBAN = function (u) {
        var v;
        if (this.isValidBBAN(u)) return v = ("0" + (98 - m(d(this.countryCode + "00" + u)))).slice(-2), this.countryCode + v + u;
        throw new Error("Invalid BBAN");
      }, s.prototype.isValidBBAN = function (u) {
        return this.length - 4 == u.length && this._regex().test(u);
      };
      var E = {};
      function c(u) {
        E[u.countryCode] = u;
      }
      c(new s("AD", 24, "F04F04A12", "AD1200012030200359100100")), c(new s("AE", 23, "F03F16", "AE070331234567890123456")), c(new s("AL", 28, "F08A16", "AL47212110090000000235698741")), c(new s("AT", 20, "F05F11", "AT611904300234573201")), c(new s("AZ", 28, "U04A20", "AZ21NABZ00000000137010001944")), c(new s("BA", 20, "F03F03F08F02", "BA391290079401028494")), c(new s("BE", 16, "F03F07F02", "BE68539007547034")), c(new s("BG", 22, "U04F04F02A08", "BG80BNBG96611020345678")), c(new s("BH", 22, "U04A14", "BH67BMAG00001299123456")), c(new s("BR", 29, "F08F05F10U01A01", "BR9700360305000010009795493P1")), c(new s("BY", 28, "A04F04A16", "BY13NBRB3600900000002Z00AB00")), c(new s("CH", 21, "F05A12", "CH9300762011623852957")), c(new s("CR", 22, "F04F14", "CR72012300000171549015")), c(new s("CY", 28, "F03F05A16", "CY17002001280000001200527600")), c(new s("CZ", 24, "F04F06F10", "CZ6508000000192000145399")), c(new s("DE", 22, "F08F10", "DE89370400440532013000")), c(new s("DK", 18, "F04F09F01", "DK5000400440116243")), c(new s("DO", 28, "U04F20", "DO28BAGR00000001212453611324")), c(new s("EE", 20, "F02F02F11F01", "EE382200221020145685")), c(new s("EG", 29, "F04F04F17", "EG800002000156789012345180002")), c(new s("ES", 24, "F04F04F01F01F10", "ES9121000418450200051332")), c(new s("FI", 18, "F06F07F01", "FI2112345600000785")), c(new s("FO", 18, "F04F09F01", "FO6264600001631634")), c(new s("FR", 27, "F05F05A11F02", "FR1420041010050500013M02606")), c(new s("GB", 22, "U04F06F08", "GB29NWBK60161331926819")), c(new s("GE", 22, "U02F16", "GE29NB0000000101904917")), c(new s("GI", 23, "U04A15", "GI75NWBK000000007099453")), c(new s("GL", 18, "F04F09F01", "GL8964710001000206")), c(new s("GR", 27, "F03F04A16", "GR1601101250000000012300695")), c(new s("GT", 28, "A04A20", "GT82TRAJ01020000001210029690")), c(new s("HR", 21, "F07F10", "HR1210010051863000160")), c(new s("HU", 28, "F03F04F01F15F01", "HU42117730161111101800000000")), c(new s("IE", 22, "U04F06F08", "IE29AIBK93115212345678")), c(new s("IL", 23, "F03F03F13", "IL620108000000099999999")), c(new s("IS", 26, "F04F02F06F10", "IS140159260076545510730339")), c(new s("IT", 27, "U01F05F05A12", "IT60X0542811101000000123456")), c(new s("IQ", 23, "U04F03A12", "IQ98NBIQ850123456789012")), c(new s("JO", 30, "A04F22", "JO15AAAA1234567890123456789012")), c(new s("KW", 30, "U04A22", "KW81CBKU0000000000001234560101")), c(new s("KZ", 20, "F03A13", "KZ86125KZT5004100100")), c(new s("LB", 28, "F04A20", "LB62099900000001001901229114")), c(new s("LC", 32, "U04F24", "LC07HEMM000100010012001200013015")), c(new s("LI", 21, "F05A12", "LI21088100002324013AA")), c(new s("LT", 20, "F05F11", "LT121000011101001000")), c(new s("LU", 20, "F03A13", "LU280019400644750000")), c(new s("LV", 21, "U04A13", "LV80BANK0000435195001")), c(new s("MC", 27, "F05F05A11F02", "MC5811222000010123456789030")), c(new s("MD", 24, "U02A18", "MD24AG000225100013104168")), c(new s("ME", 22, "F03F13F02", "ME25505000012345678951")), c(new s("MK", 19, "F03A10F02", "MK07250120000058984")), c(new s("MR", 27, "F05F05F11F02", "MR1300020001010000123456753")), c(new s("MT", 31, "U04F05A18", "MT84MALT011000012345MTLCAST001S")), c(new s("MU", 30, "U04F02F02F12F03U03", "MU17BOMM0101101030300200000MUR")), c(new s("NL", 18, "U04F10", "NL91ABNA0417164300")), c(new s("NO", 15, "F04F06F01", "NO9386011117947")), c(new s("PK", 24, "U04A16", "PK36SCBL0000001123456702")), c(new s("PL", 28, "F08F16", "PL61109010140000071219812874")), c(new s("PS", 29, "U04A21", "PS92PALS000000000400123456702")), c(new s("PT", 25, "F04F04F11F02", "PT50000201231234567890154")), c(new s("QA", 29, "U04A21", "QA30AAAA123456789012345678901")), c(new s("RO", 24, "U04A16", "RO49AAAA1B31007593840000")), c(new s("RS", 22, "F03F13F02", "RS35260005601001611379")), c(new s("SA", 24, "F02A18", "SA0380000000608010167519")), c(new s("SC", 31, "U04F04F16U03", "SC18SSCB11010000000000001497USD")), c(new s("SE", 24, "F03F16F01", "SE4550000000058398257466")), c(new s("SI", 19, "F05F08F02", "SI56263300012039086")), c(new s("SK", 24, "F04F06F10", "SK3112000000198742637541")), c(new s("SM", 27, "U01F05F05A12", "SM86U0322509800000000270100")), c(new s("ST", 25, "F08F11F02", "ST68000100010051845310112")), c(new s("SV", 28, "U04F20", "SV62CENR00000000000000700025")), c(new s("TL", 23, "F03F14F02", "TL380080012345678910157")), c(new s("TN", 24, "F02F03F13F02", "TN5910006035183598478831")), c(new s("TR", 26, "F05F01A16", "TR330006100519786457841326")), c(new s("UA", 29, "F25", "UA511234567890123456789012345")), c(new s("VA", 22, "F18", "VA59001123000012345678")), c(new s("VG", 24, "U04F16", "VG96VPVG0000012345678901")), c(new s("XK", 20, "F04F10F02", "XK051212012345678906")), c(new s("AO", 25, "F21", "AO69123456789012345678901")), c(new s("BF", 27, "F23", "BF2312345678901234567890123")), c(new s("BI", 16, "F12", "BI41123456789012")), c(new s("BJ", 28, "F24", "BJ39123456789012345678901234")), c(new s("CI", 28, "U02F22", "CI70CI1234567890123456789012")), c(new s("CM", 27, "F23", "CM9012345678901234567890123")), c(new s("CV", 25, "F21", "CV30123456789012345678901")), c(new s("DZ", 24, "F20", "DZ8612345678901234567890")), c(new s("IR", 26, "F22", "IR861234568790123456789012")), c(new s("MG", 27, "F23", "MG1812345678901234567890123")), c(new s("ML", 28, "U01F23", "ML15A12345678901234567890123")), c(new s("MZ", 25, "F21", "MZ25123456789012345678901")), c(new s("SN", 28, "U01F23", "SN52A12345678901234567890123")), c(new s("GF", 27, "F05F05A11F02", "GF121234512345123456789AB13")), c(new s("GP", 27, "F05F05A11F02", "GP791234512345123456789AB13")), c(new s("MQ", 27, "F05F05A11F02", "MQ221234512345123456789AB13")), c(new s("RE", 27, "F05F05A11F02", "RE131234512345123456789AB13")), c(new s("PF", 27, "F05F05A11F02", "PF281234512345123456789AB13")), c(new s("TF", 27, "F05F05A11F02", "TF891234512345123456789AB13")), c(new s("YT", 27, "F05F05A11F02", "YT021234512345123456789AB13")), c(new s("NC", 27, "F05F05A11F02", "NC551234512345123456789AB13")), c(new s("BL", 27, "F05F05A11F02", "BL391234512345123456789AB13")), c(new s("MF", 27, "F05F05A11F02", "MF551234512345123456789AB13")), c(new s("PM", 27, "F05F05A11F02", "PM071234512345123456789AB13")), c(new s("WF", 27, "F05F05A11F02", "WF621234512345123456789AB13"));
      var x = /[^a-zA-Z0-9]/g,
        F = /(.{4})(?!$)/g;
      function _(u) {
        return typeof u == "string" || u instanceof String;
      }
      a.isValid = function (u) {
        if (!_(u)) return !1;
        u = f(u);
        var v = E[u.slice(0, 2)];
        return !!v && v.isValid(u);
      }, a.toBBAN = function (u, v) {
        v === void 0 && (v = " "), u = f(u);
        var y = E[u.slice(0, 2)];
        if (y) return y.toBBAN(u, v);
        throw new Error("No country with code " + u.slice(0, 2));
      }, a.fromBBAN = function (u, v) {
        var y = E[u];
        if (y) return y.fromBBAN(f(v));
        throw new Error("No country with code " + u);
      }, a.isValidBBAN = function (u, v) {
        return !!_(v) && (u = E[u]) && u.isValidBBAN(f(v));
      }, a.printFormat = function (u, v) {
        return v === void 0 && (v = " "), f(u).replace(F, "$1" + v);
      }, a.electronicFormat = f, a.countries = E;
    }, typeof t.nodeName != "string" ? n(t) : n(r.IBAN = {});
  }),
  xr = function (e) {
    return Ge.printFormat(e, 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : " ");
  },
  jt = function (e) {
    return e - 97 * Math.floor(e / 97);
  };
function Vt(e) {
  return e < 10 ? "0" + e : "" + e;
}
var Xt = {
    BEL: 651,
    LUX: 359
  },
  Me = {
    BEL: "BEL",
    LUX: "LUX"
  },
  Zt = {
    BEL: "BE",
    LUX: "LU"
  },
  Jn = 7,
  Nr = function (e) {
    var t,
      r = (1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {}).country,
      r = r === void 0 ? Me.BEL : r;
    return r in Me && r in Xt ? r === Me.LUX ? (t = (t = jt(parseInt(e))) === 0 ? "97" : Vt(t), (1e3 * (359e10 + parseInt("" + e + t))).toString()) : (t = "" + Xt[r] + e) + (r = (r = jt(parseInt(t, 10))) === 0 ? "97" : Vt(r)) : e.toString();
  },
  ea = function (e) {
    var t,
      r = (1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {}).country,
      r = r === void 0 ? Me.BEL : r;
    return r in Me ? (t = Nr(e, {
      country: r
    }), r === Me.LUX ? Ge.fromBBAN(Zt.LUX, t) : Ge.fromBBAN(Zt.BEL, t)) : e.toString();
  },
  ta = function (e) {
    return +e.replace(/[\W_]+/g, "").slice(7, 7 + Jn);
  },
  ra = {
    format: xr,
    getBBANfromAccountId: Nr,
    getIBANfromAccountId: ea,
    getAccountIdFromIBAN: ta
  },
  na = "5071",
  aa = "5072",
  oa = "beneficiaries";
function sa(e, t) {
  return [na, aa].includes(t) ? e.substr(0, 7) + "** ****" + e.substr(14) : e;
}
var ia = function (e) {
    return e ? e.replace(/[^a-zA-Z0-9- ]/g, "") : "";
  },
  ua = function (e) {
    var t = 1 < arguments.length && arguments[1] !== void 0 && arguments[1],
      r = e.isTrading || e.isInvestment || e.isTreeTop,
      n = e.type === oa ? e.accountNum : e.IBAN;
    return e.contractNumber || (r = r ? e.accountID : ia(n), sa(t ? xr(r.toString()) : r.toString(), e.accountType));
  },
  Br = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (e) {
    return typeof e;
  } : function (e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
  Rr = function (e, t) {
    if (Array.isArray(e)) return e;
    if (Symbol.iterator in Object(e)) {
      var r = t,
        n = [],
        a = !0,
        t = !1,
        o = void 0;
      try {
        for (var i, d = e[Symbol.iterator](); !(a = (i = d.next()).done) && (n.push(i.value), !r || n.length !== r); a = !0);
      } catch (f) {
        t = !0, o = f;
      } finally {
        try {
          !a && d.return && d.return();
        } finally {
          if (t) throw o;
        }
      }
      return n;
    }
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  },
  ca = function (e) {
    return Array.isArray(e) ? e : Array.from(e);
  },
  la = "*",
  fa = /[^0-9A-Z]/g,
  da = function (e, t, a) {
    var n = {
        startMaskPos: 6,
        endMaskPos: 12
      },
      a = (a !== null && (a === void 0 ? "undefined" : Br(a)) === "object" && (n = Object.assign(n, a)), String(e).replace(fa, ""));
    return a ? (a = t ? a : "" + a.substring(0, n.startMaskPos) + la.repeat(n.endMaskPos - n.startMaskPos) + a.substring(n.endMaskPos)).replace(/(?!^)(?=(?:[A-Z0-9*]{4})+(?:\.|$))/gm, " ") : "";
  },
  pa = {
    convertLocalToUniversalTimeStamp: function (e) {
      return e === null ? e : ((e = new Date(1e3 * e)).getTime() + 6e4 * e.getTimezoneOffset()) / 1e3;
    }
  },
  ha = " ",
  ma = ",",
  Kt = /[^0-9 .,-]/g,
  ga = /\B(?=(\d{3})+(?!\d))/g;
function Ct(e) {
  var t,
    r,
    n = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : 2,
    o = arguments[2],
    a = {
      forceCommas: !1,
      forceFloat: !0,
      zeroValue: 0,
      limitDecimals: !0,
      thousandsSeparator: ha,
      decimalSeparator: ma,
      allowPrecision: !1
    },
    o = (o !== null && (o === void 0 ? "undefined" : Br(o)) === "object" && (a = Object.assign(a, o)), String(e).replace(Kt, "")),
    i = o.includes(",") || o.includes("."),
    d = 1 / Math.pow(10, n || 1);
  return String(e).match(Kt) || (e = String(o).replace(a.decimalSeparator, ".").replace(/\s/g, ""), t = Math.pow(10, n), r = void 0, r = a.forceFloat && a.limitDecimals ? (Math.round(e + "e+" + n) / t).toFixed(n) : a.limitDecimals && !a.allowPrecision ? (Math.round(e + "e+" + n) / t).toString() : e, !o && o !== 0) || isNaN(parseFloat(r)) ? "" : a.zeroValue !== 0 && parseFloat(o) < d ? a.zeroValue : (t = r.split(/[.,]/), o = (e = Rr(t, 2))[0], r = (d = e[1]) === void 0 ? "" : d, 4 < (o = o.replace(/\s/gi, "")).replace("-", "").length && (o = o.replace(ga, a.thousandsSeparator)), a.limitDecimals && (r = r ? r.substr(0, n) : ""), a.forceCommas ? [o, r].join(a.decimalSeparator) : a.allowPrecision ? i ? [o, r].join(a.decimalSeparator) : o : r.length ? [o, r].join(a.decimalSeparator) : o);
}
function Sa(e) {
  return e / 100;
}
var ya = function (e) {
    var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : "EUR";
    return Ct(e, 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : 2, arguments[3]) + " " + t;
  },
  va = "00";
function wa(e) {
  var t;
  return !!(e && 10 < e.length) && "+" + (t = (t = e).substr(0, 2) === va ? e.substr(2) : t).substr(0, 2) + " " + t.substr(2, 3) + " " + t.substr(5, 2) + " " + t.substr(7, 2) + " " + t.substr(9, 2);
}
var ba = {
    formatBelgianMobileNumber: wa
  },
  Aa = function (e) {
    var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : 2,
      r = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : 0,
      n = !(3 < arguments.length && arguments[3] !== void 0) || arguments[3];
    if (t === null && (t = 2), !e) {
      if (isNaN(r)) return r;
      e = r;
    }
    return Ct(e, t, n ? {} : {
      thousandsSeparator: "",
      decimalSeparator: "."
    });
  },
  Ea = {
    formatTradingPrice: Aa
  },
  Ta = /\s*/g,
  Da = /[,.]/g,
  _a = function (e) {
    return parseFloat(("" + e).replace(Ta, "").replace(Da, "."));
  },
  Fa = function (e) {
    var t, r;
    return e ? (r = (e = e.replace(/[^0-9]/g, "")).slice(0, 3), t = e.slice(3, 7), e = e.slice(7, 12), "" + r + (r = function (n) {
      return n ? "/" : "";
    })(t) + t + r(e) + e) : "";
  };
function Ma(e) {
  return e instanceof Date;
}
var It = Ma,
  ct = 36e5,
  Ke = 6e4,
  Ca = 2,
  Ia = /[T ]/,
  Oa = /:/,
  ka = /^(\d{2})$/,
  xa = [/^([+-]\d{2})$/, /^([+-]\d{3})$/, /^([+-]\d{4})$/],
  Na = /^(\d{4})/,
  Ba = [/^([+-]\d{4})/, /^([+-]\d{5})/, /^([+-]\d{6})/],
  Ra = /^-(\d{2})$/,
  Pa = /^-?(\d{3})$/,
  Ya = /^-?(\d{2})-?(\d{2})$/,
  La = /^-?W(\d{2})$/,
  Ga = /^-?W(\d{2})-?(\d{1})$/,
  $a = /^(\d{2}([.,]\d*)?)$/,
  Ha = /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  Ua = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  Wa = /([Z+-].*)$/,
  za = /^(Z)$/,
  ja = /^([+-])(\d{2})$/,
  Va = /^([+-])(\d{2}):?(\d{2})$/;
function Xa(e, t) {
  var r, n, a;
  return It(e) ? new Date(e.getTime()) : typeof e == "string" && (t = (t = (t || {}).additionalDigits) == null ? Ca : Number(t), n = (t = Ka((r = Za(e)).date, t)).year, t = Qa(t.restDateString, n)) ? (n = t.getTime(), t = 0, r.time && (t = qa(r.time)), a = r.timezone ? Ja(r.timezone) : (a = new Date(n + t).getTimezoneOffset(), new Date(n + t + a * Ke).getTimezoneOffset()), new Date(n + t + a * Ke)) : new Date(e);
}
function Za(n) {
  var t,
    r = {},
    n = n.split(Ia),
    n = Oa.test(n[0]) ? (r.date = null, n[0]) : (r.date = n[0], n[1]);
  return n && ((t = Wa.exec(n)) ? (r.time = n.replace(t[1], ""), r.timezone = t[1]) : r.time = n), r;
}
function Ka(e, a) {
  var r,
    n = xa[a],
    a = Ba[a],
    a = Na.exec(e) || a.exec(e);
  return a ? (r = a[1], {
    year: parseInt(r, 10),
    restDateString: e.slice(r.length)
  }) : (a = ka.exec(e) || n.exec(e)) ? (r = a[1], {
    year: 100 * parseInt(r, 10),
    restDateString: e.slice(r.length)
  }) : {
    year: null
  };
}
function Qa(e, t) {
  var r, n, a, o;
  return t === null ? null : e.length === 0 ? ((n = /* @__PURE__ */new Date(0)).setUTCFullYear(t), n) : (r = Ra.exec(e)) ? (n = /* @__PURE__ */new Date(0), a = parseInt(r[1], 10) - 1, n.setUTCFullYear(t, a), n) : (r = Pa.exec(e)) ? (n = /* @__PURE__ */new Date(0), o = parseInt(r[1], 10), n.setUTCFullYear(t, 0, o), n) : (r = Ya.exec(e)) ? (n = /* @__PURE__ */new Date(0), a = parseInt(r[1], 10) - 1, o = parseInt(r[2], 10), n.setUTCFullYear(t, a, o), n) : (r = La.exec(e)) ? Qt(t, parseInt(r[1], 10) - 1) : (r = Ga.exec(e)) ? Qt(t, parseInt(r[1], 10) - 1, parseInt(r[2], 10) - 1) : null;
}
function qa(e) {
  var t,
    r,
    n = $a.exec(e);
  return n ? (t = parseFloat(n[1].replace(",", "."))) % 24 * ct : (n = Ha.exec(e)) ? (t = parseInt(n[1], 10), r = parseFloat(n[2].replace(",", ".")), t % 24 * ct + r * Ke) : (n = Ua.exec(e)) ? (t = parseInt(n[1], 10), r = parseInt(n[2], 10), e = parseFloat(n[3].replace(",", ".")), t % 24 * ct + r * Ke + 1e3 * e) : null;
}
function Ja(e) {
  var t,
    r = za.exec(e);
  return r ? 0 : (r = ja.exec(e)) ? (t = 60 * parseInt(r[2], 10), r[1] === "+" ? -t : t) : (r = Va.exec(e)) ? (t = 60 * parseInt(r[2], 10) + parseInt(r[3], 10), r[1] === "+" ? -t : t) : 0;
}
function Qt(e, t, r) {
  t = t || 0, r = r || 0;
  var n = /* @__PURE__ */new Date(0);
  return n.setUTCFullYear(e, 0, 4), e = 7 * t + r + 1 - (n.getUTCDay() || 7), n.setUTCDate(n.getUTCDate() + e), n;
}
var p = Xa;
function eo(e, t) {
  return e = p(e), t = Number(t), e.setDate(e.getDate() + t), e;
}
var He = eo;
function to(e, t) {
  return e = p(e).getTime(), t = Number(t), new Date(e + t);
}
var Ue = to,
  ro = 36e5;
function no(e, t) {
  return t = Number(t), Ue(e, t * ro);
}
var Pr = no;
function ao(n, r) {
  var r = r && Number(r.weekStartsOn) || 0,
    n = p(n),
    a = n.getDay(),
    a = (a < r ? 7 : 0) + a - r;
  return n.setDate(n.getDate() - a), n.setHours(0, 0, 0, 0), n;
}
var Ce = ao;
function oo(e) {
  return Ce(e, {
    weekStartsOn: 1
  });
}
var ge = oo;
function so(t) {
  var t = p(t),
    r = t.getFullYear(),
    n = /* @__PURE__ */new Date(0),
    n = (n.setFullYear(r + 1, 0, 4), n.setHours(0, 0, 0, 0), ge(n)),
    a = /* @__PURE__ */new Date(0),
    a = (a.setFullYear(r, 0, 4), a.setHours(0, 0, 0, 0), ge(a));
  return t.getTime() >= n.getTime() ? r + 1 : t.getTime() >= a.getTime() ? r : r - 1;
}
var Se = so;
function io(t) {
  var t = Se(t),
    r = /* @__PURE__ */new Date(0);
  return r.setFullYear(t, 0, 4), r.setHours(0, 0, 0, 0), ge(r);
}
var Ee = io;
function uo(e) {
  return e = p(e), e.setHours(0, 0, 0, 0), e;
}
var ie = uo,
  qt = 6e4,
  co = 864e5;
function lo(e, t) {
  return e = ie(e), t = ie(t), e = e.getTime() - e.getTimezoneOffset() * qt, t = t.getTime() - t.getTimezoneOffset() * qt, Math.round((e - t) / co);
}
var nt = lo;
function fo(r, n) {
  var r = p(r),
    n = Number(n),
    a = nt(r, Ee(r)),
    o = /* @__PURE__ */new Date(0);
  return o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0), (r = Ee(o)).setDate(r.getDate() + a), r;
}
var Yr = fo;
function po(e, t) {
  return t = Number(t), Yr(e, Se(e) + t);
}
var Lr = po,
  ho = 6e4;
function mo(e, t) {
  return t = Number(t), Ue(e, t * ho);
}
var Gr = mo;
function go(r) {
  var r = p(r),
    t = r.getFullYear(),
    r = r.getMonth(),
    n = /* @__PURE__ */new Date(0);
  return n.setFullYear(t, r + 1, 0), n.setHours(0, 0, 0, 0), n.getDate();
}
var Ot = go;
function So(r, n) {
  var r = p(r),
    n = Number(n),
    n = r.getMonth() + n,
    a = /* @__PURE__ */new Date(0),
    a = (a.setFullYear(r.getFullYear(), n, 1), a.setHours(0, 0, 0, 0), Ot(a));
  return r.setMonth(n, Math.min(a, r.getDate())), r;
}
var at = So;
function yo(e, t) {
  return t = Number(t), at(e, 3 * t);
}
var $r = yo;
function vo(e, t) {
  return t = Number(t), Ue(e, 1e3 * t);
}
var Hr = vo;
function wo(e, t) {
  return t = Number(t), He(e, 7 * t);
}
var kt = wo;
function bo(e, t) {
  return t = Number(t), at(e, 12 * t);
}
var Ur = bo;
function Ao(e, t, r, n) {
  if (e = p(e).getTime(), t = p(t).getTime(), r = p(r).getTime(), n = p(n).getTime(), t < e || n < r) throw new Error("The start of the range cannot be after the end of the range");
  return e < n && r < t;
}
var Eo = Ao;
function To(e, t) {
  var r, n, a;
  if (t instanceof Array) return r = p(e).getTime(), t.forEach(function (o, i) {
    o = p(o), o = Math.abs(r - o.getTime()), (n === void 0 || o < a) && (n = i, a = o);
  }), n;
  throw new TypeError(toString.call(t) + " is not an instance of Array");
}
var Do = To;
function _o(e, t) {
  var r, n, a;
  if (t instanceof Array) return r = p(e).getTime(), t.forEach(function (i) {
    var i = p(i),
      d = Math.abs(r - i.getTime());
    (n === void 0 || d < a) && (n = i, a = d);
  }), n;
  throw new TypeError(toString.call(t) + " is not an instance of Array");
}
var Fo = _o;
function Mo(e, t) {
  return e = p(e).getTime(), t = p(t).getTime(), e < t ? -1 : t < e ? 1 : 0;
}
var ye = Mo;
function Co(e, t) {
  return e = p(e).getTime(), t = p(t).getTime(), t < e ? -1 : e < t ? 1 : 0;
}
var xt = Co,
  Jt = 6e4,
  Io = 6048e5;
function Oo(e, t) {
  return e = ge(e), t = ge(t), e = e.getTime() - e.getTimezoneOffset() * Jt, t = t.getTime() - t.getTimezoneOffset() * Jt, Math.round((e - t) / Io);
}
var ko = Oo;
function xo(e, t) {
  return Se(e) - Se(t);
}
var Wr = xo;
function No(e, t) {
  return e = p(e), t = p(t), 12 * (e.getFullYear() - t.getFullYear()) + (e.getMonth() - t.getMonth());
}
var zr = No;
function Bo(e) {
  return e = p(e), Math.floor(e.getMonth() / 3) + 1;
}
var pt = Bo;
function Ro(e, t) {
  return e = p(e), t = p(t), 4 * (e.getFullYear() - t.getFullYear()) + (pt(e) - pt(t));
}
var Po = Ro,
  er = 6e4,
  Yo = 6048e5;
function Lo(e, t, r) {
  return e = Ce(e, r), t = Ce(t, r), r = e.getTime() - e.getTimezoneOffset() * er, e = t.getTime() - t.getTimezoneOffset() * er, Math.round((r - e) / Yo);
}
var Go = Lo;
function $o(e, t) {
  return e = p(e), t = p(t), e.getFullYear() - t.getFullYear();
}
var jr = $o;
function Ho(r, n) {
  var r = p(r),
    n = p(n),
    a = ye(r, n),
    o = Math.abs(nt(r, n));
  return r.setDate(r.getDate() - a * o), a * (o - (ye(r, n) === -a));
}
var Vr = Ho;
function Uo(e, t) {
  return e = p(e), t = p(t), e.getTime() - t.getTime();
}
var ot = Uo,
  Wo = 36e5;
function zo(e, t) {
  return e = ot(e, t) / Wo, 0 < e ? Math.floor(e) : Math.ceil(e);
}
var jo = zo;
function Vo(e, t) {
  return t = Number(t), Lr(e, -t);
}
var Xr = Vo;
function Xo(o, r) {
  var o = p(o),
    r = p(r),
    n = ye(o, r),
    a = Math.abs(Wr(o, r)),
    o = Xr(o, n * a);
  return n * (a - (ye(o, r) === -n));
}
var Zo = Xo,
  Ko = 6e4;
function Qo(e, t) {
  return e = ot(e, t) / Ko, 0 < e ? Math.floor(e) : Math.ceil(e);
}
var qo = Qo;
function Jo(r, n) {
  var r = p(r),
    n = p(n),
    a = ye(r, n),
    o = Math.abs(zr(r, n));
  return r.setMonth(r.getMonth() - a * o), a * (o - (ye(r, n) === -a));
}
var Nt = Jo;
function es(e, t) {
  return e = Nt(e, t) / 3, 0 < e ? Math.floor(e) : Math.ceil(e);
}
var ts = es;
function rs(e, t) {
  return e = ot(e, t) / 1e3, 0 < e ? Math.floor(e) : Math.ceil(e);
}
var Bt = rs;
function ns(e, t) {
  return e = Vr(e, t) / 7, 0 < e ? Math.floor(e) : Math.ceil(e);
}
var as = ns;
function os(r, n) {
  var r = p(r),
    n = p(n),
    a = ye(r, n),
    o = Math.abs(jr(r, n));
  return r.setFullYear(r.getFullYear() - a * o), a * (o - (ye(r, n) === -a));
}
var ss = os;
function is() {
  var e = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  };
  return {
    localize: function (t, r, n) {
      return n = n || {}, t = typeof e[t] == "string" ? e[t] : r === 1 ? e[t].one : e[t].other.replace("{{count}}", r), n.addSuffix ? 0 < n.comparison ? "in " + t : t + " ago" : t;
    }
  };
}
var us = ["M", "MM", "Q", "D", "DD", "DDD", "DDDD", "d", "E", "W", "WW", "YY", "YYYY", "GG", "GGGG", "H", "HH", "h", "hh", "m", "mm", "s", "ss", "S", "SS", "SSS", "Z", "ZZ", "X", "x"];
function cs(e) {
  var t,
    r = [];
  for (t in e) e.hasOwnProperty(t) && r.push(t);
  var n = us.concat(r).sort().reverse();
  return new RegExp("(\\[[^\\[]*\\])|(\\\\)?(" + n.join("|") + "|.)", "g");
}
var ls = cs;
function fs() {
  var e = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    t = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    r = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    n = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    a = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    o = ["AM", "PM"],
    i = ["am", "pm"],
    d = ["a.m.", "p.m."],
    m = {
      MMM: function (f) {
        return e[f.getMonth()];
      },
      MMMM: function (f) {
        return t[f.getMonth()];
      },
      dd: function (f) {
        return r[f.getDay()];
      },
      ddd: function (f) {
        return n[f.getDay()];
      },
      dddd: function (f) {
        return a[f.getDay()];
      },
      A: function (f) {
        return 1 <= f.getHours() / 12 ? o[1] : o[0];
      },
      a: function (f) {
        return 1 <= f.getHours() / 12 ? i[1] : i[0];
      },
      aa: function (f) {
        return 1 <= f.getHours() / 12 ? d[1] : d[0];
      }
    };
  return ["M", "D", "DDD", "d", "Q", "W"].forEach(function (f) {
    m[f + "o"] = function (s, E) {
      return ds(E[f](s));
    };
  }), {
    formatters: m,
    formattingTokensRegExp: ls(m)
  };
}
function ds(e) {
  var t = e % 100;
  if (20 < t || t < 10) switch (t % 10) {
    case 1:
      return e + "st";
    case 2:
      return e + "nd";
    case 3:
      return e + "rd";
  }
  return e + "th";
}
var ps = fs,
  Qe = {
    distanceInWords: is(),
    format: ps()
  },
  tr = 1440,
  hs = 2520,
  lt = 43200,
  ms = 86400;
function gs(s, f, o) {
  var n,
    a,
    o = o || {},
    m = xt(s, f),
    d = o.locale,
    i = Qe.distanceInWords.localize,
    d = (d && d.distanceInWords && d.distanceInWords.localize && (i = d.distanceInWords.localize), {
      addSuffix: !!o.addSuffix,
      comparison: m
    }),
    m = 0 < m ? (n = p(s), p(f)) : (n = p(f), p(s)),
    f = Bt(m, n),
    s = m.getTimezoneOffset() - n.getTimezoneOffset(),
    s = Math.round(f / 60) - s;
  return s < 2 ? o.includeSeconds ? f < 5 ? i("lessThanXSeconds", 5, d) : f < 10 ? i("lessThanXSeconds", 10, d) : f < 20 ? i("lessThanXSeconds", 20, d) : f < 40 ? i("halfAMinute", null, d) : i(f < 60 ? "lessThanXMinutes" : "xMinutes", 1, d) : s == 0 ? i("lessThanXMinutes", 1, d) : i("xMinutes", s, d) : s < 45 ? i("xMinutes", s, d) : s < 90 ? i("aboutXHours", 1, d) : s < tr ? i("aboutXHours", Math.round(s / 60), d) : s < hs ? i("xDays", 1, d) : s < lt ? i("xDays", Math.round(s / tr), d) : s < ms ? i("aboutXMonths", a = Math.round(s / lt), d) : (a = Nt(m, n)) < 12 ? i("xMonths", Math.round(s / lt), d) : (o = a % 12, f = Math.floor(a / 12), o < 3 ? i("aboutXYears", f, d) : o < 9 ? i("overXYears", f, d) : i("almostXYears", f + 1, d));
}
var Zr = gs,
  rr = 1440,
  nr = 43200,
  ar = 525600;
function Ss(d, i, n) {
  var n = n || {},
    f = xt(d, i),
    o = n.locale,
    a = Qe.distanceInWords.localize,
    o = (o && o.distanceInWords && o.distanceInWords.localize && (a = o.distanceInWords.localize), {
      addSuffix: !!n.addSuffix,
      comparison: f
    }),
    f = 0 < f ? (m = p(d), p(i)) : (m = p(i), p(d)),
    i = Math[n.partialMethod ? String(n.partialMethod) : "floor"],
    d = Bt(f, m),
    f = f.getTimezoneOffset() - m.getTimezoneOffset(),
    m = i(d / 60) - f,
    f = n.unit ? String(n.unit) : m < 1 ? "s" : m < 60 ? "m" : m < rr ? "h" : m < nr ? "d" : m < ar ? "M" : "Y";
  if (f === "s") return a("xSeconds", d, o);
  if (f === "m") return a("xMinutes", m, o);
  if (f === "h") return a("xHours", i(m / 60), o);
  if (f === "d") return a("xDays", i(m / rr), o);
  if (f === "M") return a("xMonths", i(m / nr), o);
  if (f === "Y") return a("xYears", i(m / ar), o);
  throw new Error("Unknown unit: " + f);
}
function ys(e, t) {
  return Zr(Date.now(), e, t);
}
function vs(n, t, r) {
  var n = p(n),
    a = r !== void 0 ? r : 1,
    o = p(t).getTime();
  if (n.getTime() > o) throw new Error("The first date cannot be after the second date");
  var i = [],
    d = n;
  for (d.setHours(0, 0, 0, 0); d.getTime() <= o;) i.push(p(d)), d.setDate(d.getDate() + a);
  return i;
}
function ws(e) {
  return e = p(e), e.setHours(23, 59, 59, 999), e;
}
var Rt = ws;
function bs(e) {
  return e = p(e), e.setMinutes(59, 59, 999), e;
}
function As(n, r) {
  var r = r && Number(r.weekStartsOn) || 0,
    n = p(n),
    a = n.getDay(),
    a = 6 + (a < r ? -7 : 0) - (a - r);
  return n.setDate(n.getDate() + a), n.setHours(23, 59, 59, 999), n;
}
var Kr = As;
function Es(e) {
  return Kr(e, {
    weekStartsOn: 1
  });
}
function Ts(r) {
  var r = Se(r),
    t = /* @__PURE__ */new Date(0),
    r = (t.setFullYear(r + 1, 0, 4), t.setHours(0, 0, 0, 0), ge(t));
  return r.setMilliseconds(r.getMilliseconds() - 1), r;
}
function Ds(e) {
  return e = p(e), e.setSeconds(59, 999), e;
}
function _s(t) {
  var t = p(t),
    r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(23, 59, 59, 999), t;
}
var Qr = _s;
function Fs(t) {
  var t = p(t),
    r = t.getMonth();
  return t.setMonth(r - r % 3 + 3, 0), t.setHours(23, 59, 59, 999), t;
}
function Ms(e) {
  return e = p(e), e.setMilliseconds(999), e;
}
function Cs() {
  return Rt(/* @__PURE__ */new Date());
}
function Is() {
  var r = /* @__PURE__ */new Date(),
    e = r.getFullYear(),
    t = r.getMonth(),
    r = r.getDate(),
    n = /* @__PURE__ */new Date(0);
  return n.setFullYear(e, t, r + 1), n.setHours(23, 59, 59, 999), n;
}
function Os(t) {
  var t = p(t),
    r = t.getFullYear();
  return t.setFullYear(r + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function ks() {
  var r = /* @__PURE__ */new Date(),
    e = r.getFullYear(),
    t = r.getMonth(),
    r = r.getDate(),
    n = /* @__PURE__ */new Date(0);
  return n.setFullYear(e, t, r - 1), n.setHours(23, 59, 59, 999), n;
}
function xs(t) {
  var t = p(t),
    r = /* @__PURE__ */new Date(0);
  return r.setFullYear(t.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
var qr = xs;
function Ns(e) {
  return e = p(e), nt(e, qr(e)) + 1;
}
var ht = Ns,
  Bs = 6048e5;
function Rs(e) {
  return e = p(e), e = ge(e).getTime() - Ee(e).getTime(), Math.round(e / Bs) + 1;
}
var qe = Rs;
function Ps(e) {
  if (It(e)) return !isNaN(e);
  throw new TypeError(toString.call(e) + " is not an instance of Date");
}
var Jr = Ps;
function Ys(e, n, i) {
  var n = n ? String(n) : "YYYY-MM-DDTHH:mm:ss.SSSZ",
    i = (i || {}).locale,
    a = Qe.format.formatters,
    o = Qe.format.formattingTokensRegExp,
    i = (i && i.format && i.format.formatters && (a = i.format.formatters, i.format.formattingTokensRegExp) && (o = i.format.formattingTokensRegExp), p(e));
  return Jr(i) ? Ls(n, a, o)(i) : "Invalid Date";
}
var mt = {
  M: function (e) {
    return e.getMonth() + 1;
  },
  MM: function (e) {
    return ne(e.getMonth() + 1, 2);
  },
  Q: function (e) {
    return Math.ceil((e.getMonth() + 1) / 3);
  },
  D: function (e) {
    return e.getDate();
  },
  DD: function (e) {
    return ne(e.getDate(), 2);
  },
  DDD: function (e) {
    return ht(e);
  },
  DDDD: function (e) {
    return ne(ht(e), 3);
  },
  d: function (e) {
    return e.getDay();
  },
  E: function (e) {
    return e.getDay() || 7;
  },
  W: function (e) {
    return qe(e);
  },
  WW: function (e) {
    return ne(qe(e), 2);
  },
  YY: function (e) {
    return ne(e.getFullYear(), 4).substr(2);
  },
  YYYY: function (e) {
    return ne(e.getFullYear(), 4);
  },
  GG: function (e) {
    return String(Se(e)).substr(2);
  },
  GGGG: function (e) {
    return Se(e);
  },
  H: function (e) {
    return e.getHours();
  },
  HH: function (e) {
    return ne(e.getHours(), 2);
  },
  h: function (e) {
    return e = e.getHours(), e === 0 ? 12 : 12 < e ? e % 12 : e;
  },
  hh: function (e) {
    return ne(mt.h(e), 2);
  },
  m: function (e) {
    return e.getMinutes();
  },
  mm: function (e) {
    return ne(e.getMinutes(), 2);
  },
  s: function (e) {
    return e.getSeconds();
  },
  ss: function (e) {
    return ne(e.getSeconds(), 2);
  },
  S: function (e) {
    return Math.floor(e.getMilliseconds() / 100);
  },
  SS: function (e) {
    return ne(Math.floor(e.getMilliseconds() / 10), 2);
  },
  SSS: function (e) {
    return ne(e.getMilliseconds(), 3);
  },
  Z: function (e) {
    return or(e.getTimezoneOffset(), ":");
  },
  ZZ: function (e) {
    return or(e.getTimezoneOffset());
  },
  X: function (e) {
    return Math.floor(e.getTime() / 1e3);
  },
  x: function (e) {
    return e.getTime();
  }
};
function Ls(e, t, r) {
  for (var n, a = e.match(r), o = a.length, i = 0; i < o; i++) n = t[a[i]] || mt[a[i]], a[i] = n || Gs(a[i]);
  return function (d) {
    for (var m = "", f = 0; f < o; f++) a[f] instanceof Function ? m += a[f](d, mt) : m += a[f];
    return m;
  };
}
function Gs(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|]$/g, "") : e.replace(/\\/g, "");
}
function or(n, t) {
  t = t || "";
  var r = 0 < n ? "-" : "+",
    n = Math.abs(n),
    a = n % 60;
  return r + ne(Math.floor(n / 60), 2) + t + ne(a, 2);
}
function ne(e, t) {
  for (var r = Math.abs(e).toString(); r.length < t;) r = "0" + r;
  return r;
}
function $s(e) {
  return p(e).getDate();
}
function Hs(e) {
  return p(e).getDay();
}
function Us(e) {
  return e = p(e).getFullYear(), e % 400 == 0 || e % 4 == 0 && e % 100 != 0;
}
var en = Us;
function Ws(e) {
  return en(e) ? 366 : 365;
}
function zs(e) {
  return p(e).getHours();
}
function js(e) {
  return e = p(e).getDay(), e = e === 0 ? 7 : e;
}
var tn = js,
  Vs = 6048e5;
function Xs(e) {
  return e = Ee(e), e = Ee(kt(e, 60)).valueOf() - e.valueOf(), Math.round(e / Vs);
}
function Zs(e) {
  return p(e).getMilliseconds();
}
function Ks(e) {
  return p(e).getMinutes();
}
function Qs(e) {
  return p(e).getMonth();
}
var qs = 864e5;
function Js(e, t, r, n) {
  if (e = p(e).getTime(), t = p(t).getTime(), r = p(r).getTime(), n = p(n).getTime(), t < e || n < r) throw new Error("The start of the range cannot be after the end of the range");
  return e < n && r < t ? Math.ceil(((t < n ? t : n) - (r < e ? e : r)) / qs) : 0;
}
function ei(e) {
  return p(e).getSeconds();
}
function ti(e) {
  return p(e).getTime();
}
function ri(e) {
  return p(e).getFullYear();
}
function ni(e, t) {
  return e = p(e), t = p(t), e.getTime() > t.getTime();
}
function ai(e, t) {
  return e = p(e), t = p(t), e.getTime() < t.getTime();
}
function oi(e, t) {
  return e = p(e), t = p(t), e.getTime() === t.getTime();
}
function si(e) {
  return p(e).getDate() === 1;
}
function ii(e) {
  return p(e).getDay() === 5;
}
function ui(e) {
  return p(e).getTime() > (/* @__PURE__ */new Date()).getTime();
}
function ci(e) {
  return e = p(e), Rt(e).getTime() === Qr(e).getTime();
}
function li(e) {
  return p(e).getDay() === 1;
}
function fi(e) {
  return p(e).getTime() < (/* @__PURE__ */new Date()).getTime();
}
function di(e, t) {
  return e = ie(e), t = ie(t), e.getTime() === t.getTime();
}
function pi(e) {
  return e = p(e), e.setMinutes(0, 0, 0), e;
}
var gt = pi;
function hi(e, t) {
  return e = gt(e), t = gt(t), e.getTime() === t.getTime();
}
var rn = hi;
function mi(e, t, r) {
  return e = Ce(e, r), t = Ce(t, r), e.getTime() === t.getTime();
}
var Pt = mi;
function gi(e, t) {
  return Pt(e, t, {
    weekStartsOn: 1
  });
}
var nn = gi;
function Si(e, t) {
  return e = Ee(e), t = Ee(t), e.getTime() === t.getTime();
}
var an = Si;
function yi(e) {
  return e = p(e), e.setSeconds(0, 0), e;
}
var St = yi;
function vi(e, t) {
  return e = St(e), t = St(t), e.getTime() === t.getTime();
}
var on = vi;
function wi(e, t) {
  return e = p(e), t = p(t), e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth();
}
var sn = wi;
function bi(t) {
  var t = p(t),
    r = t.getMonth();
  return t.setMonth(r - r % 3, 1), t.setHours(0, 0, 0, 0), t;
}
var yt = bi;
function Ai(e, t) {
  return e = yt(e), t = yt(t), e.getTime() === t.getTime();
}
var un = Ai;
function Ei(e) {
  return e = p(e), e.setMilliseconds(0), e;
}
var vt = Ei;
function Ti(e, t) {
  return e = vt(e), t = vt(t), e.getTime() === t.getTime();
}
var cn = Ti;
function Di(e, t) {
  return e = p(e), t = p(t), e.getFullYear() === t.getFullYear();
}
var ln = Di;
function _i(e) {
  return p(e).getDay() === 6;
}
function Fi(e) {
  return p(e).getDay() === 0;
}
function Mi(e) {
  return rn(/* @__PURE__ */new Date(), e);
}
function Ci(e) {
  return nn(/* @__PURE__ */new Date(), e);
}
function Ii(e) {
  return an(/* @__PURE__ */new Date(), e);
}
function Oi(e) {
  return on(/* @__PURE__ */new Date(), e);
}
function ki(e) {
  return sn(/* @__PURE__ */new Date(), e);
}
function xi(e) {
  return un(/* @__PURE__ */new Date(), e);
}
function Ni(e) {
  return cn(/* @__PURE__ */new Date(), e);
}
function Bi(e, t) {
  return Pt(/* @__PURE__ */new Date(), e, t);
}
function Ri(e) {
  return ln(/* @__PURE__ */new Date(), e);
}
function Pi(e) {
  return p(e).getDay() === 4;
}
function Yi(e) {
  return ie(e).getTime() === ie(/* @__PURE__ */new Date()).getTime();
}
function Li(e) {
  var t = /* @__PURE__ */new Date();
  return t.setDate(t.getDate() + 1), ie(e).getTime() === ie(t).getTime();
}
function Gi(e) {
  return p(e).getDay() === 2;
}
function $i(e) {
  return p(e).getDay() === 3;
}
function Hi(e) {
  return e = p(e).getDay(), e === 0 || e === 6;
}
function Ui(e, t, r) {
  if (e = p(e).getTime(), t = p(t).getTime(), r = p(r).getTime(), r < t) throw new Error("The start of the range cannot be after the end of the range");
  return t <= e && e <= r;
}
function Wi(e) {
  var t = /* @__PURE__ */new Date();
  return t.setDate(t.getDate() - 1), ie(e).getTime() === ie(t).getTime();
}
function zi(n, r) {
  var r = r && Number(r.weekStartsOn) || 0,
    n = p(n),
    a = n.getDay(),
    a = 6 + (a < r ? -7 : 0) - (a - r);
  return n.setHours(0, 0, 0, 0), n.setDate(n.getDate() + a), n;
}
var fn = zi;
function ji(e) {
  return fn(e, {
    weekStartsOn: 1
  });
}
function Vi(r) {
  var r = Se(r),
    t = /* @__PURE__ */new Date(0),
    r = (t.setFullYear(r + 1, 0, 4), t.setHours(0, 0, 0, 0), ge(t));
  return r.setDate(r.getDate() - 1), r;
}
function Xi(t) {
  var t = p(t),
    r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(0, 0, 0, 0), t;
}
function Zi(t) {
  var t = p(t),
    r = t.getMonth();
  return t.setMonth(r - r % 3 + 3, 0), t.setHours(0, 0, 0, 0), t;
}
function Ki(t) {
  var t = p(t),
    r = t.getFullYear();
  return t.setFullYear(r + 1, 0, 0), t.setHours(0, 0, 0, 0), t;
}
function Qi() {
  var e = Array.prototype.slice.call(arguments).map(function (t) {
      return p(t);
    }),
    e = Math.max.apply(null, e);
  return new Date(e);
}
function qi() {
  var e = Array.prototype.slice.call(arguments).map(function (t) {
      return p(t);
    }),
    e = Math.min.apply(null, e);
  return new Date(e);
}
function Ji(e, t) {
  return e = p(e), t = Number(t), e.setDate(t), e;
}
function eu(a, o, n) {
  var n = n && Number(n.weekStartsOn) || 0,
    a = p(a),
    o = Number(o),
    i = a.getDay();
  return He(a, ((7 + o % 7) % 7 < n ? 7 : 0) + o - i);
}
function tu(e, t) {
  return e = p(e), t = Number(t), e.setMonth(0), e.setDate(t), e;
}
function ru(e, t) {
  return e = p(e), t = Number(t), e.setHours(t), e;
}
function nu(r, n) {
  var r = p(r),
    n = Number(n),
    a = tn(r);
  return He(r, n - a);
}
function au(e, t) {
  return e = p(e), t = Number(t), t = qe(e) - t, e.setDate(e.getDate() - 7 * t), e;
}
function ou(e, t) {
  return e = p(e), t = Number(t), e.setMilliseconds(t), e;
}
function su(e, t) {
  return e = p(e), t = Number(t), e.setMinutes(t), e;
}
function iu(r, n) {
  var r = p(r),
    n = Number(n),
    i = r.getFullYear(),
    a = r.getDate(),
    o = /* @__PURE__ */new Date(0),
    i = (o.setFullYear(i, n, 15), o.setHours(0, 0, 0, 0), Ot(o));
  return r.setMonth(n, Math.min(a, i)), r;
}
var dn = iu;
function uu(e, t) {
  return e = p(e), t = Number(t) - (Math.floor(e.getMonth() / 3) + 1), dn(e, e.getMonth() + 3 * t);
}
function cu(e, t) {
  return e = p(e), t = Number(t), e.setSeconds(t), e;
}
function lu(e, t) {
  return e = p(e), t = Number(t), e.setFullYear(t), e;
}
function fu(e) {
  return e = p(e), e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
function du() {
  return ie(/* @__PURE__ */new Date());
}
function pu() {
  var r = /* @__PURE__ */new Date(),
    e = r.getFullYear(),
    t = r.getMonth(),
    r = r.getDate(),
    n = /* @__PURE__ */new Date(0);
  return n.setFullYear(e, t, r + 1), n.setHours(0, 0, 0, 0), n;
}
function hu() {
  var r = /* @__PURE__ */new Date(),
    e = r.getFullYear(),
    t = r.getMonth(),
    r = r.getDate(),
    n = /* @__PURE__ */new Date(0);
  return n.setFullYear(e, t, r - 1), n.setHours(0, 0, 0, 0), n;
}
function mu(e, t) {
  return t = Number(t), He(e, -t);
}
function gu(e, t) {
  return t = Number(t), Pr(e, -t);
}
function Su(e, t) {
  return t = Number(t), Ue(e, -t);
}
function yu(e, t) {
  return t = Number(t), Gr(e, -t);
}
function vu(e, t) {
  return t = Number(t), at(e, -t);
}
function wu(e, t) {
  return t = Number(t), $r(e, -t);
}
function bu(e, t) {
  return t = Number(t), Hr(e, -t);
}
function Au(e, t) {
  return t = Number(t), kt(e, -t);
}
function Eu(e, t) {
  return t = Number(t), Ur(e, -t);
}
var Tu = {
    addDays: He,
    addHours: Pr,
    addISOYears: Lr,
    addMilliseconds: Ue,
    addMinutes: Gr,
    addMonths: at,
    addQuarters: $r,
    addSeconds: Hr,
    addWeeks: kt,
    addYears: Ur,
    areRangesOverlapping: Eo,
    closestIndexTo: Do,
    closestTo: Fo,
    compareAsc: ye,
    compareDesc: xt,
    differenceInCalendarDays: nt,
    differenceInCalendarISOWeeks: ko,
    differenceInCalendarISOYears: Wr,
    differenceInCalendarMonths: zr,
    differenceInCalendarQuarters: Po,
    differenceInCalendarWeeks: Go,
    differenceInCalendarYears: jr,
    differenceInDays: Vr,
    differenceInHours: jo,
    differenceInISOYears: Zo,
    differenceInMilliseconds: ot,
    differenceInMinutes: qo,
    differenceInMonths: Nt,
    differenceInQuarters: ts,
    differenceInSeconds: Bt,
    differenceInWeeks: as,
    differenceInYears: ss,
    distanceInWords: Zr,
    distanceInWordsStrict: Ss,
    distanceInWordsToNow: ys,
    eachDay: vs,
    endOfDay: Rt,
    endOfHour: bs,
    endOfISOWeek: Es,
    endOfISOYear: Ts,
    endOfMinute: Ds,
    endOfMonth: Qr,
    endOfQuarter: Fs,
    endOfSecond: Ms,
    endOfToday: Cs,
    endOfTomorrow: Is,
    endOfWeek: Kr,
    endOfYear: Os,
    endOfYesterday: ks,
    format: Ys,
    getDate: $s,
    getDay: Hs,
    getDayOfYear: ht,
    getDaysInMonth: Ot,
    getDaysInYear: Ws,
    getHours: zs,
    getISODay: tn,
    getISOWeek: qe,
    getISOWeeksInYear: Xs,
    getISOYear: Se,
    getMilliseconds: Zs,
    getMinutes: Ks,
    getMonth: Qs,
    getOverlappingDaysInRanges: Js,
    getQuarter: pt,
    getSeconds: ei,
    getTime: ti,
    getYear: ri,
    isAfter: ni,
    isBefore: ai,
    isDate: It,
    isEqual: oi,
    isFirstDayOfMonth: si,
    isFriday: ii,
    isFuture: ui,
    isLastDayOfMonth: ci,
    isLeapYear: en,
    isMonday: li,
    isPast: fi,
    isSameDay: di,
    isSameHour: rn,
    isSameISOWeek: nn,
    isSameISOYear: an,
    isSameMinute: on,
    isSameMonth: sn,
    isSameQuarter: un,
    isSameSecond: cn,
    isSameWeek: Pt,
    isSameYear: ln,
    isSaturday: _i,
    isSunday: Fi,
    isThisHour: Mi,
    isThisISOWeek: Ci,
    isThisISOYear: Ii,
    isThisMinute: Oi,
    isThisMonth: ki,
    isThisQuarter: xi,
    isThisSecond: Ni,
    isThisWeek: Bi,
    isThisYear: Ri,
    isThursday: Pi,
    isToday: Yi,
    isTomorrow: Li,
    isTuesday: Gi,
    isValid: Jr,
    isWednesday: $i,
    isWeekend: Hi,
    isWithinRange: Ui,
    isYesterday: Wi,
    lastDayOfISOWeek: ji,
    lastDayOfISOYear: Vi,
    lastDayOfMonth: Xi,
    lastDayOfQuarter: Zi,
    lastDayOfWeek: fn,
    lastDayOfYear: Ki,
    max: Qi,
    min: qi,
    parse: p,
    setDate: Ji,
    setDay: eu,
    setDayOfYear: tu,
    setHours: ru,
    setISODay: nu,
    setISOWeek: au,
    setISOYear: Yr,
    setMilliseconds: ou,
    setMinutes: su,
    setMonth: dn,
    setQuarter: uu,
    setSeconds: cu,
    setYear: lu,
    startOfDay: ie,
    startOfHour: gt,
    startOfISOWeek: ge,
    startOfISOYear: Ee,
    startOfMinute: St,
    startOfMonth: fu,
    startOfQuarter: yt,
    startOfSecond: vt,
    startOfToday: du,
    startOfTomorrow: pu,
    startOfWeek: Ce,
    startOfYear: qr,
    startOfYesterday: hu,
    subDays: mu,
    subHours: gu,
    subISOYears: Xr,
    subMilliseconds: Su,
    subMinutes: yu,
    subMonths: vu,
    subQuarters: wu,
    subSeconds: bu,
    subWeeks: Au,
    subYears: Eu
  },
  Du = Tu.format,
  _u = "YYYY-MM-DDTHH:mm:ss",
  Fu = function (e) {
    var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : _u;
    return Du(new Date(1e3 * e), t);
  },
  pn = {
    accountNumber: ua,
    creditCardNumber: da,
    dateTime: pa,
    iban: ra,
    money: ya,
    number: Ct,
    convertAmountFromCentsToEuros: Sa,
    phone: ba,
    price: Ea,
    stringToNumber: _a,
    structuredMessage: Fa,
    timestamp: Fu
  },
  hn = "mobile",
  mn = "tablet",
  gn = "desktop",
  Mu = function () {
    return window.innerWidth < ut.SIZE_MD ? hn : window.innerWidth >= ut.SIZE_MD && window.innerWidth <= ut.SIZE_XL ? mn : gn;
  },
  Cu = {
    MOBILE: hn,
    TABLET: mn,
    DESKTOP: gn,
    getCurrentResolution: Mu
  },
  Sn = {
    resolutions: Cu
  },
  Iu = /[‘°µ£€!§@#$%^&*()_+=[\]{};:"\\|,.<>/?]/,
  Ou = /\d/,
  ku = function (e) {
    return !Iu.test(e);
  },
  xu = function (e) {
    return !Ou.test(e);
  },
  Nu = {
    doesNotContainSpecialCharacters: ku,
    doesNotContainDigit: xu
  },
  Bu = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  Ru = function (e) {
    return Bu.test(e);
  },
  Pu = {
    isValid: Ru
  },
  Yu = /^[+\d./ ]+$/,
  Lu = function (e) {
    return Yu.test(e);
  },
  Gu = function (r) {
    var r = r.split(" "),
      r = ca(r),
      t = r[0],
      r = r.slice(1);
    return t === "32" && (t = (t = r.join("").replace(" ", "")).charAt(0) === "0" ? t.substr(1) : t).charAt(0) === "4" && t.length === 9;
  },
  $u = function (e) {
    return !!e && 5 <= (e = e.split(" ")[1]).length && e.length <= 20;
  },
  Hu = {
    isValid: Lu,
    isBelgianCompliant: Gu,
    lengthIsValid: $u
  },
  Uu = function (a) {
    var r = /* @__PURE__ */new Date(),
      t = r.getFullYear(),
      r = r.getMonth() + 1,
      a = (r < 10 && (r = "0" + r), a.split("/")),
      a = Rr(a, 2),
      n = a[0],
      a = a[1];
    return !(!a || !n || n.length !== 2 || a.length !== 4) && parseInt("" + a + n) < parseInt("" + t + r);
  },
  Wu = {
    isMonthInThePast: Uu
  },
  Je = Or.list,
  zu = function (e) {
    return Ge.isValid(e);
  },
  ju = function (e) {
    return e.substr(0, 2) === "BE";
  },
  Vu = function (e) {
    return e.substr(0, 2) === "LU";
  },
  yn = function (e) {
    return e && e.substring(0, 2).toLowerCase();
  },
  vn = function (e) {
    return e = yn(e), !e || Je[e] && Je[e].isSepa;
  },
  Xu = function (e, t, r, n) {
    return e = vn(e), n = !n || Je[n.toLowerCase()] && Je[n.toLowerCase()].isSepa, !((!r || r === t) && e && n);
  },
  Zu = {
    validate: zu,
    isBelgian: ju,
    isLuxembourg: Vu,
    isSepa: vn,
    getIBANPrefix: yn,
    isInternational: Xu
  },
  Ku = function (e) {
    return Ge.isValidBBAN(1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : "BE", e);
  },
  Qu = {
    validate: Ku
  },
  wn = {
    common: Nu,
    email: Pu,
    phone: Hu,
    date: Wu,
    iban: Zu,
    bban: Qu
  },
  qu = {
    config: kr,
    format: pn,
    helpers: Sn,
    validation: wn
  };
_e.default = qu, _e.config = kr, Mr = _e.format = pn, _e.helpers = Sn, _e.validation = wn;
const bn = {
    test: "www.test.w.keytradebank.be",
    stage: "www.stage.w.keytradebank.be",
    prod: "www.keytradebank.be"
  },
  Ju = "/node/backend",
  ec = e => {
    const {
        hostname: t
      } = window.location,
      r = t === "localhost" ? `${bn.test}${Ju}` : `${t}/node/backend`,
      n = e.startsWith("/") ? e.slice(1) : e;
    return encodeURI(`https://${r}/${n}`);
  },
  de = async e => {
    const t = ec(e),
      r = new URL(t);
    try {
      if (Object.values(bn).includes(r.hostname)) {
        const n = await fetch(r.toString());
        if (!n.ok) throw new Error(`Failed to fetch data from ${t}`);
        return await n.json();
      } else throw new Error("Invalid URL");
    } catch (n) {
      throw console.error(`Error fetching data from ${t}:`, n), n;
    }
  },
  be = "cldprxy/chancloud";
var ve = (e => (e.whatsNew = `${be}/v1/content/whatsnew`, e.microcopy = `${be}/v1/content/microcopy`, e.promoMessages = `${be}/v1/content/promo-messages`, e.savingRates = `${be}/v1/content/saving-rates`, e.documents = `${be}/v1/content/documents`, e.urgentMessage = `${be}/v1/content/urgentmessage`, e.articles = `${be}/v1/content/articles`, e.detailedProducts = `${be}/v1/content/detailed-products`, e))(ve || {});
const tc = async () => de(ve.whatsNew),
  rc = async () => de(ve.microcopy),
  nc = async () => de(ve.promoMessages),
  ac = async () => de(ve.savingRates),
  oc = async () => de(ve.documents),
  sc = async () => de(ve.urgentMessage),
  ic = async () => de(ve.articles),
  uc = async _ref => {
    let {
      lang: e,
      productName: t
    } = _ref;
    return de(`${ve.detailedProducts}?lang=${e}&productName=${t}`);
  },
  cc = {
    getWhatsNew: tc,
    getMicrocopy: rc,
    getPromoMessages: nc,
    getSavingRates: ac,
    getDocuments: oc,
    getUrgentMessage: sc,
    getArticles: ic,
    getDetailedProduct: uc
  },
  lc = async () => de("v1/trading/markets?type=I"
  /* marketsTypeI */),
  fc = async () => de("v1/trading/markets?type=F"
  /* marketsTypeF */),
  dc = {
    getMarketsTypeI: lc,
    getMarketsTypeF: fc
  },
  sr = {
    contentful: cc,
    markets: dc
  },
  pc = "SEURUSD",
  An = "EURUSD",
  hc = (e, t) => e.filter(r => t.includes(r.symbol)),
  mc = e => e.map(t => {
    const {
      name: r,
      lastPrice: n,
      variation: a,
      open: o
    } = t;
    let i = r;
    return r === pc && (i = An), {
      name: i,
      lastPrice: n,
      variation: a,
      open: o !== !1
      // Some index like EURUSD have "null" as "open" value
    };
  }),
  ir = (e, t) => {
    const r = hc(e, t);
    return mc(r);
  },
  Yt = 4e3,
  ur = ["BEL20",
  // BEL20
  "AEX",
  // AEX
  "PX1",
  // CAC 40
  "I:DJI",
  // Dow Jones
  "I:NDX"
  // Nasdaq 100
  ],
  cr = ["X:SEURUSD"
  // USD
  ],
  gc = () => {
    const [e, t] = _r([]);
    return Fr(() => {
      const r = async () => {
        try {
          const [o, i] = await Promise.all([sr.markets.getMarketsTypeI(), sr.markets.getMarketsTypeF()]),
            {
              data: d
            } = o,
            {
              data: m
            } = i,
            f = [...ir(d, ur), ...ir(m, cr)];
          t(f);
        } catch (o) {
          console.log("Error while fetching indexes: ", o), t([]);
        }
      };
      r();
      const n = (cr.length + ur.length) * 2 * Yt,
        a = setInterval(r, n);
      return () => clearInterval(a);
    }, []), e;
  },
  Fe = {
    AeroBlue: "#c6eada",
    AzureX: "#e6f7fb",
    AzureXDark: "#0a1f26",
    BabyPink: "#f8c9c5",
    Black: "#000000",
    BlackTransparent: "rgba(0,0,0,0.7)",
    BlackTransparentLight: "rgba(0,0,0,0.2)",
    BlackTransparentMedium: "rgba(0,0,0,0.35)",
    BlizzardBlue: "#b3e8f4",
    BlueCloudy: "#a7bdcc",
    BlueCloudyTransparent: "rgba(167,189,204,0.5)",
    BlueDark: "#2c3b45",
    BlueDarkGradient: "linear-gradient(-225deg, rgb(44, 59, 69) 0%, rgb(78, 98, 110) 100%)",
    BlueDawn: "#007f9e",
    BlueFog: "#CEDAE1",
    BlueHeaven: "#64dfff",
    BlueLight: "#E4EBEF",
    BlueLightGradient: "linear-gradient(-225deg, rgb(235, 249, 252) 0%, rgb(191, 240, 247) 100%)",
    BlueMoon: "#3c5463",
    BlueNight: "#1D6478",
    BlueSky: "#00b3db",
    BlueSkyVivid: "#33c2e2",
    BlueSmoke: "#F1F5F7",
    Bittersweet: "#ed7064",
    Bunker: "#171E24",
    DeepChampagne: "#fbd38d",
    GreenDark: "#19a568",
    GreenFlash: "#44DB5E",
    GreenGarden: "#029231",
    GreenLight: "#52cb95",
    GreenMedium: "#1AAF5D",
    GreenOcean: "#67c89d",
    GreenSeafoam: "#41ba84",
    Grey: "#e6e8e9",
    GreyBackground: "#ebf0f2",
    GreyBlue: "#5A7A8E",
    GreyBright: "#f7f7f7",
    GreyDark: "#5e6467",
    GreyLight: "#d8d8d8",
    GreyMedium: "#b7b7b7",
    GreyWarm: "#959da2",
    GreyWhite: "#efefef",
    HoneyDew: "#d9f1e6",
    HoneyDewDark: "#153127",
    LavenderBlush: "#fdedec",
    LavenderBlushDark: "#201516",
    LightCyan: "#ccf0f8",
    LightCyanDark: "#07313A",
    MagicMint: "#b3e3ce",
    Melon: "#f6b7b1",
    MintCream: "#ecf8f3",
    MintCreamDark: "#10201D",
    MistyRose: "#fadbd8",
    MistyRoseDark: "#361B1A",
    NonPhotoBlue: "#99e1f1",
    OldLace: "#fef6e8",
    OldLaceDark: "#221E13",
    Orange: "#f7a71a",
    OrangeDark: "#ff860f",
    PapayaWhip: "#fdedd1",
    PapayaWhipDark: "#392D13",
    Peach: "#fde5da",
    Purple: "#b90059",
    Sunary: "#f9c15f",
    Tomato: "#e84c3d",
    TomatoDark: "#ca4036",
    TomatoLight: "#eb8b84",
    TomatoFlash: "#CB1212",
    Transparent: "transparent",
    VisaGold: "#a18950",
    VisaPlatinum: "#86898b",
    White: "#ffffff",
    WhiteTransparent: "rgba(255,255,255,0.3)",
    YellowVanilla: "#fbf4d3",
    /// NEW COLORS v2
    //// MONOCHROME
    Grey10Ghost: "#F7F9FA",
    Grey20Smoke: "#F2F5F7",
    Grey30Mist: "#E6EDF0",
    Grey40Haze: "#DAE3E8",
    Grey50Fog: "#CEDAE0",
    Grey60Smog: "#BAC8CF",
    Grey70Cloudy: "#A9BAC4",
    Grey80Concrete: "#A0B1BA",
    Grey90Silver: "#94A7B0",
    Grey100Steel: "#889CA6",
    Grey200Slate: "#7C919C",
    Grey300Lead: "#7C919C",
    Grey400Iron: "#677C87",
    Grey500Titanium: "#5C727D",
    Grey600Graphite: "#536673",
    Grey700Obsidian: "#495C69",
    Grey800Darkblue: "#2C3B45",
    Grey850Shadow: "#24323C",
    Grey900Night: "#1E2A33",
    Grey950Pitchdark: "#172026",
    Grey1000Black: "#000000",
    //// RED
    Red100: "#FAE9E7",
    Red200: "#F6D2CE",
    Red300: "#EDA59D",
    Red400: "#E3786D",
    Red500: "#DA4B3C",
    Red600: "#D11E0B",
    Red700: "#A71809",
    Red800: "#7D1207",
    //// ORANGE
    Orange100: "#FEF6E8",
    Orange200: "#FDEDD1",
    Orange300: "#FCDCA3",
    Orange400: "#FACA76",
    Orange500: "#F9B948",
    Orange600: "#F7A71A",
    Orange700: "#DE9617",
    Orange800: "#C68615",
    Orange900: "#8A6628",
    //// GREEN
    Green100: "#E6F3EE",
    Green200: "#CDE8DE",
    Green300: "#9AD0BD",
    Green400: "#35A17A",
    Green500: "#1C9166",
    Green600: "#038153",
    Green700: "#026E47",
    Green800: "#025335",
    //// Blue
    Blue100: "#E6F7FB",
    Blue200: "#CCF0F8",
    Blue300: "#B3E8F4",
    Blue400: "#99E1F1",
    Blue500: "#33C2E2",
    Blue600Sky: "#00B3DB",
    Blue700Dawn: "#007F9E",
    Blue800: "#006480",
    Blue900: "#004B60"
  };
var se = /* @__PURE__ */(e => (e.positive = "positive", e.negative = "negative", e.equal = "equal", e))(se || {});
const Sc = e => e > 0.01 ? se.positive : e < -0.01 ? se.negative : se.equal,
  yc = (e, t) => {
    if (!t) return Fe.Grey60Smog;
    switch (e) {
      case se.positive:
        return Fe.Green300;
      case se.negative:
        return Fe.Red200;
      case se.equal:
      default:
        return Fe.Grey60Smog;
    }
  };
var wt = {
    exports: {}
  },
  P = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lr;
function vc() {
  if (lr) return P;
  lr = 1;
  var e = Symbol.for("react.element"),
    t = Symbol.for("react.portal"),
    r = Symbol.for("react.fragment"),
    n = Symbol.for("react.strict_mode"),
    a = Symbol.for("react.profiler"),
    o = Symbol.for("react.provider"),
    i = Symbol.for("react.context"),
    d = Symbol.for("react.server_context"),
    m = Symbol.for("react.forward_ref"),
    f = Symbol.for("react.suspense"),
    s = Symbol.for("react.suspense_list"),
    E = Symbol.for("react.memo"),
    c = Symbol.for("react.lazy"),
    x = Symbol.for("react.offscreen"),
    F;
  F = Symbol.for("react.module.reference");
  function _(u) {
    if (typeof u == "object" && u !== null) {
      var v = u.$$typeof;
      switch (v) {
        case e:
          switch (u = u.type, u) {
            case r:
            case a:
            case n:
            case f:
            case s:
              return u;
            default:
              switch (u = u && u.$$typeof, u) {
                case d:
                case i:
                case m:
                case c:
                case E:
                case o:
                  return u;
                default:
                  return v;
              }
          }
        case t:
          return v;
      }
    }
  }
  return P.ContextConsumer = i, P.ContextProvider = o, P.Element = e, P.ForwardRef = m, P.Fragment = r, P.Lazy = c, P.Memo = E, P.Portal = t, P.Profiler = a, P.StrictMode = n, P.Suspense = f, P.SuspenseList = s, P.isAsyncMode = function () {
    return !1;
  }, P.isConcurrentMode = function () {
    return !1;
  }, P.isContextConsumer = function (u) {
    return _(u) === i;
  }, P.isContextProvider = function (u) {
    return _(u) === o;
  }, P.isElement = function (u) {
    return typeof u == "object" && u !== null && u.$$typeof === e;
  }, P.isForwardRef = function (u) {
    return _(u) === m;
  }, P.isFragment = function (u) {
    return _(u) === r;
  }, P.isLazy = function (u) {
    return _(u) === c;
  }, P.isMemo = function (u) {
    return _(u) === E;
  }, P.isPortal = function (u) {
    return _(u) === t;
  }, P.isProfiler = function (u) {
    return _(u) === a;
  }, P.isStrictMode = function (u) {
    return _(u) === n;
  }, P.isSuspense = function (u) {
    return _(u) === f;
  }, P.isSuspenseList = function (u) {
    return _(u) === s;
  }, P.isValidElementType = function (u) {
    return typeof u == "string" || typeof u == "function" || u === r || u === a || u === n || u === f || u === s || u === x || typeof u == "object" && u !== null && (u.$$typeof === c || u.$$typeof === E || u.$$typeof === o || u.$$typeof === i || u.$$typeof === m || u.$$typeof === F || u.getModuleId !== void 0);
  }, P.typeOf = _, P;
}
var Y = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fr;
function wc() {
  return fr || (fr = 1, process.env.NODE_ENV !== "production" && function () {
    var e = Symbol.for("react.element"),
      t = Symbol.for("react.portal"),
      r = Symbol.for("react.fragment"),
      n = Symbol.for("react.strict_mode"),
      a = Symbol.for("react.profiler"),
      o = Symbol.for("react.provider"),
      i = Symbol.for("react.context"),
      d = Symbol.for("react.server_context"),
      m = Symbol.for("react.forward_ref"),
      f = Symbol.for("react.suspense"),
      s = Symbol.for("react.suspense_list"),
      E = Symbol.for("react.memo"),
      c = Symbol.for("react.lazy"),
      x = Symbol.for("react.offscreen"),
      F = !1,
      _ = !1,
      u = !1,
      v = !1,
      y = !1,
      M;
    M = Symbol.for("react.module.reference");
    function D(w) {
      return !!(typeof w == "string" || typeof w == "function" || w === r || w === a || y || w === n || w === f || w === s || v || w === x || F || _ || u || typeof w == "object" && w !== null && (w.$$typeof === c || w.$$typeof === E || w.$$typeof === o || w.$$typeof === i || w.$$typeof === m ||
      // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      w.$$typeof === M || w.getModuleId !== void 0));
    }
    function h(w) {
      if (typeof w == "object" && w !== null) {
        var O = w.$$typeof;
        switch (O) {
          case e:
            var U = w.type;
            switch (U) {
              case r:
              case a:
              case n:
              case f:
              case s:
                return U;
              default:
                var R = U && U.$$typeof;
                switch (R) {
                  case d:
                  case i:
                  case m:
                  case c:
                  case E:
                  case o:
                    return R;
                  default:
                    return O;
                }
            }
          case t:
            return O;
        }
      }
    }
    var j = i,
      ae = o,
      q = e,
      te = m,
      oe = r,
      le = c,
      Z = E,
      J = t,
      re = a,
      V = n,
      pe = f,
      ee = s,
      X = !1,
      fe = !1;
    function ue(w) {
      return X || (X = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function he(w) {
      return fe || (fe = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function T(w) {
      return h(w) === i;
    }
    function b(w) {
      return h(w) === o;
    }
    function A(w) {
      return typeof w == "object" && w !== null && w.$$typeof === e;
    }
    function C(w) {
      return h(w) === m;
    }
    function l(w) {
      return h(w) === r;
    }
    function N(w) {
      return h(w) === c;
    }
    function S(w) {
      return h(w) === E;
    }
    function $(w) {
      return h(w) === t;
    }
    function B(w) {
      return h(w) === a;
    }
    function k(w) {
      return h(w) === n;
    }
    function g(w) {
      return h(w) === f;
    }
    function H(w) {
      return h(w) === s;
    }
    Y.ContextConsumer = j, Y.ContextProvider = ae, Y.Element = q, Y.ForwardRef = te, Y.Fragment = oe, Y.Lazy = le, Y.Memo = Z, Y.Portal = J, Y.Profiler = re, Y.StrictMode = V, Y.Suspense = pe, Y.SuspenseList = ee, Y.isAsyncMode = ue, Y.isConcurrentMode = he, Y.isContextConsumer = T, Y.isContextProvider = b, Y.isElement = A, Y.isForwardRef = C, Y.isFragment = l, Y.isLazy = N, Y.isMemo = S, Y.isPortal = $, Y.isProfiler = B, Y.isStrictMode = k, Y.isSuspense = g, Y.isSuspenseList = H, Y.isValidElementType = D, Y.typeOf = h;
  }()), Y;
}
process.env.NODE_ENV === "production" ? wt.exports = vc() : wt.exports = wc();
var Lt = wt.exports;
function bc(e) {
  function t(T, b, A, C, l) {
    for (var N = 0, S = 0, $ = 0, B = 0, k, g, H = 0, w = 0, O, U = O = k = 0, R = 0, K = 0, xe = 0, Q = 0, We = A.length, Ne = We - 1, ce, I = "", W = "", st = "", it = "", we; R < We;) {
      if (g = A.charCodeAt(R), R === Ne && S + B + $ + N !== 0 && (S !== 0 && (g = S === 47 ? 10 : 47), B = $ = N = 0, We++, Ne++), S + B + $ + N === 0) {
        if (R === Ne && (0 < K && (I = I.replace(c, "")), 0 < I.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              I += A.charAt(R);
          }
          g = 59;
        }
        switch (g) {
          case 123:
            for (I = I.trim(), k = I.charCodeAt(0), O = 1, Q = ++R; R < We;) {
              switch (g = A.charCodeAt(R)) {
                case 123:
                  O++;
                  break;
                case 125:
                  O--;
                  break;
                case 47:
                  switch (g = A.charCodeAt(R + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (U = R + 1; U < Ne; ++U) switch (A.charCodeAt(U)) {
                          case 47:
                            if (g === 42 && A.charCodeAt(U - 1) === 42 && R + 2 !== U) {
                              R = U + 1;
                              break e;
                            }
                            break;
                          case 10:
                            if (g === 47) {
                              R = U + 1;
                              break e;
                            }
                        }
                        R = U;
                      }
                  }
                  break;
                case 91:
                  g++;
                case 40:
                  g++;
                case 34:
                case 39:
                  for (; R++ < Ne && A.charCodeAt(R) !== g;);
              }
              if (O === 0) break;
              R++;
            }
            switch (O = A.substring(Q, R), k === 0 && (k = (I = I.replace(E, "").trim()).charCodeAt(0)), k) {
              case 64:
                switch (0 < K && (I = I.replace(c, "")), g = I.charCodeAt(1), g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    K = b;
                    break;
                  default:
                    K = pe;
                }
                if (O = t(b, K, O, g, l + 1), Q = O.length, 0 < X && (K = r(pe, I, xe), we = d(3, O, K, b, J, Z, Q, g, l, C), I = K.join(""), we !== void 0 && (Q = (O = we.trim()).length) === 0 && (g = 0, O = "")), 0 < Q) switch (g) {
                  case 115:
                    I = I.replace(j, i);
                  case 100:
                  case 109:
                  case 45:
                    O = I + "{" + O + "}";
                    break;
                  case 107:
                    I = I.replace(y, "$1 $2"), O = I + "{" + O + "}", O = V === 1 || V === 2 && o("@" + O, 3) ? "@-webkit-" + O + "@" + O : "@" + O;
                    break;
                  default:
                    O = I + O, C === 112 && (O = (W += O, ""));
                } else O = "";
                break;
              default:
                O = t(b, r(b, I, xe), O, C, l + 1);
            }
            st += O, O = xe = K = U = k = 0, I = "", g = A.charCodeAt(++R);
            break;
          case 125:
          case 59:
            if (I = (0 < K ? I.replace(c, "") : I).trim(), 1 < (Q = I.length)) switch (U === 0 && (k = I.charCodeAt(0), k === 45 || 96 < k && 123 > k) && (Q = (I = I.replace(" ", ":")).length), 0 < X && (we = d(1, I, b, T, J, Z, W.length, C, l, C)) !== void 0 && (Q = (I = we.trim()).length) === 0 && (I = "\0\0"), k = I.charCodeAt(0), g = I.charCodeAt(1), k) {
              case 0:
                break;
              case 64:
                if (g === 105 || g === 99) {
                  it += I + A.charAt(R);
                  break;
                }
              default:
                I.charCodeAt(Q - 1) !== 58 && (W += a(I, k, g, I.charCodeAt(2)));
            }
            xe = K = U = k = 0, I = "", g = A.charCodeAt(++R);
        }
      }
      switch (g) {
        case 13:
        case 10:
          S === 47 ? S = 0 : 1 + k === 0 && C !== 107 && 0 < I.length && (K = 1, I += "\0"), 0 < X * ue && d(0, I, b, T, J, Z, W.length, C, l, C), Z = 1, J++;
          break;
        case 59:
        case 125:
          if (S + B + $ + N === 0) {
            Z++;
            break;
          }
        default:
          switch (Z++, ce = A.charAt(R), g) {
            case 9:
            case 32:
              if (B + N + S === 0) switch (H) {
                case 44:
                case 58:
                case 9:
                case 32:
                  ce = "";
                  break;
                default:
                  g !== 32 && (ce = " ");
              }
              break;
            case 0:
              ce = "\\0";
              break;
            case 12:
              ce = "\\f";
              break;
            case 11:
              ce = "\\v";
              break;
            case 38:
              B + S + N === 0 && (K = xe = 1, ce = "\f" + ce);
              break;
            case 108:
              if (B + S + N + re === 0 && 0 < U) switch (R - U) {
                case 2:
                  H === 112 && A.charCodeAt(R - 3) === 58 && (re = H);
                case 8:
                  w === 111 && (re = w);
              }
              break;
            case 58:
              B + S + N === 0 && (U = R);
              break;
            case 44:
              S + $ + B + N === 0 && (K = 1, ce += "\r");
              break;
            case 34:
            case 39:
              S === 0 && (B = B === g ? 0 : B === 0 ? g : B);
              break;
            case 91:
              B + S + $ === 0 && N++;
              break;
            case 93:
              B + S + $ === 0 && N--;
              break;
            case 41:
              B + S + N === 0 && $--;
              break;
            case 40:
              if (B + S + N === 0) {
                if (k === 0) switch (2 * H + 3 * w) {
                  case 533:
                    break;
                  default:
                    k = 1;
                }
                $++;
              }
              break;
            case 64:
              S + $ + B + N + U + O === 0 && (O = 1);
              break;
            case 42:
            case 47:
              if (!(0 < B + N + $)) switch (S) {
                case 0:
                  switch (2 * g + 3 * A.charCodeAt(R + 1)) {
                    case 235:
                      S = 47;
                      break;
                    case 220:
                      Q = R, S = 42;
                  }
                  break;
                case 42:
                  g === 47 && H === 42 && Q + 2 !== R && (A.charCodeAt(Q + 2) === 33 && (W += A.substring(Q, R + 1)), ce = "", S = 0);
              }
          }
          S === 0 && (I += ce);
      }
      w = H, H = g, R++;
    }
    if (Q = W.length, 0 < Q) {
      if (K = b, 0 < X && (we = d(2, W, K, T, J, Z, Q, C, l, C), we !== void 0 && (W = we).length === 0)) return it + W + st;
      if (W = K.join(",") + "{" + W + "}", V * re !== 0) {
        switch (V !== 2 || o(W, 2) || (re = 0), re) {
          case 111:
            W = W.replace(D, ":-moz-$1") + W;
            break;
          case 112:
            W = W.replace(M, "::-webkit-input-$1") + W.replace(M, "::-moz-$1") + W.replace(M, ":-ms-input-$1") + W;
        }
        re = 0;
      }
    }
    return it + W + st;
  }
  function r(T, b, A) {
    var C = b.trim().split(u);
    b = C;
    var l = C.length,
      N = T.length;
    switch (N) {
      case 0:
      case 1:
        var S = 0;
        for (T = N === 0 ? "" : T[0] + " "; S < l; ++S) b[S] = n(T, b[S], A).trim();
        break;
      default:
        var $ = S = 0;
        for (b = []; S < l; ++S) for (var B = 0; B < N; ++B) b[$++] = n(T[B] + " ", C[S], A).trim();
    }
    return b;
  }
  function n(T, b, A) {
    var C = b.charCodeAt(0);
    switch (33 > C && (C = (b = b.trim()).charCodeAt(0)), C) {
      case 38:
        return b.replace(v, "$1" + T.trim());
      case 58:
        return T.trim() + b.replace(v, "$1" + T.trim());
      default:
        if (0 < 1 * A && 0 < b.indexOf("\f")) return b.replace(v, (T.charCodeAt(0) === 58 ? "" : "$1") + T.trim());
    }
    return T + b;
  }
  function a(T, b, A, C) {
    var l = T + ";",
      N = 2 * b + 3 * A + 4 * C;
    if (N === 944) {
      T = l.indexOf(":", 9) + 1;
      var S = l.substring(T, l.length - 1).trim();
      return S = l.substring(0, T).trim() + S + ";", V === 1 || V === 2 && o(S, 1) ? "-webkit-" + S + S : S;
    }
    if (V === 0 || V === 2 && !o(l, 1)) return l;
    switch (N) {
      case 1015:
        return l.charCodeAt(10) === 97 ? "-webkit-" + l + l : l;
      case 951:
        return l.charCodeAt(3) === 116 ? "-webkit-" + l + l : l;
      case 963:
        return l.charCodeAt(5) === 110 ? "-webkit-" + l + l : l;
      case 1009:
        if (l.charCodeAt(4) !== 100) break;
      case 969:
      case 942:
        return "-webkit-" + l + l;
      case 978:
        return "-webkit-" + l + "-moz-" + l + l;
      case 1019:
      case 983:
        return "-webkit-" + l + "-moz-" + l + "-ms-" + l + l;
      case 883:
        if (l.charCodeAt(8) === 45) return "-webkit-" + l + l;
        if (0 < l.indexOf("image-set(", 11)) return l.replace(le, "$1-webkit-$2") + l;
        break;
      case 932:
        if (l.charCodeAt(4) === 45) switch (l.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + l.replace("-grow", "") + "-webkit-" + l + "-ms-" + l.replace("grow", "positive") + l;
          case 115:
            return "-webkit-" + l + "-ms-" + l.replace("shrink", "negative") + l;
          case 98:
            return "-webkit-" + l + "-ms-" + l.replace("basis", "preferred-size") + l;
        }
        return "-webkit-" + l + "-ms-" + l + l;
      case 964:
        return "-webkit-" + l + "-ms-flex-" + l + l;
      case 1023:
        if (l.charCodeAt(8) !== 99) break;
        return S = l.substring(l.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), "-webkit-box-pack" + S + "-webkit-" + l + "-ms-flex-pack" + S + l;
      case 1005:
        return F.test(l) ? l.replace(x, ":-webkit-") + l.replace(x, ":-moz-") + l : l;
      case 1e3:
        switch (S = l.substring(13).trim(), b = S.indexOf("-") + 1, S.charCodeAt(0) + S.charCodeAt(b)) {
          case 226:
            S = l.replace(h, "tb");
            break;
          case 232:
            S = l.replace(h, "tb-rl");
            break;
          case 220:
            S = l.replace(h, "lr");
            break;
          default:
            return l;
        }
        return "-webkit-" + l + "-ms-" + S + l;
      case 1017:
        if (l.indexOf("sticky", 9) === -1) break;
      case 975:
        switch (b = (l = T).length - 10, S = (l.charCodeAt(b) === 33 ? l.substring(0, b) : l).substring(T.indexOf(":", 7) + 1).trim(), N = S.charCodeAt(0) + (S.charCodeAt(7) | 0)) {
          case 203:
            if (111 > S.charCodeAt(8)) break;
          case 115:
            l = l.replace(S, "-webkit-" + S) + ";" + l;
            break;
          case 207:
          case 102:
            l = l.replace(S, "-webkit-" + (102 < N ? "inline-" : "") + "box") + ";" + l.replace(S, "-webkit-" + S) + ";" + l.replace(S, "-ms-" + S + "box") + ";" + l;
        }
        return l + ";";
      case 938:
        if (l.charCodeAt(5) === 45) switch (l.charCodeAt(6)) {
          case 105:
            return S = l.replace("-items", ""), "-webkit-" + l + "-webkit-box-" + S + "-ms-flex-" + S + l;
          case 115:
            return "-webkit-" + l + "-ms-flex-item-" + l.replace(q, "") + l;
          default:
            return "-webkit-" + l + "-ms-flex-line-pack" + l.replace("align-content", "").replace(q, "") + l;
        }
        break;
      case 973:
      case 989:
        if (l.charCodeAt(3) !== 45 || l.charCodeAt(4) === 122) break;
      case 931:
      case 953:
        if (oe.test(T) === !0) return (S = T.substring(T.indexOf(":") + 1)).charCodeAt(0) === 115 ? a(T.replace("stretch", "fill-available"), b, A, C).replace(":fill-available", ":stretch") : l.replace(S, "-webkit-" + S) + l.replace(S, "-moz-" + S.replace("fill-", "")) + l;
        break;
      case 962:
        if (l = "-webkit-" + l + (l.charCodeAt(5) === 102 ? "-ms-" + l : "") + l, A + C === 211 && l.charCodeAt(13) === 105 && 0 < l.indexOf("transform", 10)) return l.substring(0, l.indexOf(";", 27) + 1).replace(_, "$1-webkit-$2") + l;
    }
    return l;
  }
  function o(T, b) {
    var A = T.indexOf(b === 1 ? ":" : "{"),
      C = T.substring(0, b !== 3 ? A : 10);
    return A = T.substring(A + 1, T.length - 1), fe(b !== 2 ? C : C.replace(te, "$1"), A, b);
  }
  function i(T, b) {
    var A = a(b, b.charCodeAt(0), b.charCodeAt(1), b.charCodeAt(2));
    return A !== b + ";" ? A.replace(ae, " or ($1)").substring(4) : "(" + b + ")";
  }
  function d(T, b, A, C, l, N, S, $, B, k) {
    for (var g = 0, H = b, w; g < X; ++g) switch (w = ee[g].call(s, T, H, A, C, l, N, S, $, B, k)) {
      case void 0:
      case !1:
      case !0:
      case null:
        break;
      default:
        H = w;
    }
    if (H !== b) return H;
  }
  function m(T) {
    switch (T) {
      case void 0:
      case null:
        X = ee.length = 0;
        break;
      default:
        if (typeof T == "function") ee[X++] = T;else if (typeof T == "object") for (var b = 0, A = T.length; b < A; ++b) m(T[b]);else ue = !!T | 0;
    }
    return m;
  }
  function f(T) {
    return T = T.prefix, T !== void 0 && (fe = null, T ? typeof T != "function" ? V = 1 : (V = 2, fe = T) : V = 0), f;
  }
  function s(T, b) {
    var A = T;
    if (33 > A.charCodeAt(0) && (A = A.trim()), he = A, A = [he], 0 < X) {
      var C = d(-1, b, A, A, J, Z, 0, 0, 0, 0);
      C !== void 0 && typeof C == "string" && (b = C);
    }
    var l = t(pe, A, b, 0, 0);
    return 0 < X && (C = d(-2, l, A, A, J, Z, l.length, 0, 0, 0), C !== void 0 && (l = C)), he = "", re = 0, Z = J = 1, l;
  }
  var E = /^\0+/g,
    c = /[\0\r\f]/g,
    x = /: */g,
    F = /zoo|gra/,
    _ = /([,: ])(transform)/g,
    u = /,\r+?/g,
    v = /([\t\r\n ])*\f?&/g,
    y = /@(k\w+)\s*(\S*)\s*/,
    M = /::(place)/g,
    D = /:(read-only)/g,
    h = /[svh]\w+-[tblr]{2}/,
    j = /\(\s*(.*)\s*\)/g,
    ae = /([\s\S]*?);/g,
    q = /-self|flex-/g,
    te = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
    oe = /stretch|:\s*\w+\-(?:conte|avail)/,
    le = /([^-])(image-set\()/,
    Z = 1,
    J = 1,
    re = 0,
    V = 1,
    pe = [],
    ee = [],
    X = 0,
    fe = null,
    ue = 0,
    he = "";
  return s.use = m, s.set = f, e !== void 0 && f(e), s;
}
var Ac = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function Ec(e) {
  var t = /* @__PURE__ */Object.create(null);
  return function (r) {
    return t[r] === void 0 && (t[r] = e(r)), t[r];
  };
}
var Tc = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,
  dr = /* @__PURE__ */Ec(function (e) {
    return Tc.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */),
  bt = {
    exports: {}
  },
  L = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var pr;
function Dc() {
  if (pr) return L;
  pr = 1;
  var e = typeof Symbol == "function" && Symbol.for,
    t = e ? Symbol.for("react.element") : 60103,
    r = e ? Symbol.for("react.portal") : 60106,
    n = e ? Symbol.for("react.fragment") : 60107,
    a = e ? Symbol.for("react.strict_mode") : 60108,
    o = e ? Symbol.for("react.profiler") : 60114,
    i = e ? Symbol.for("react.provider") : 60109,
    d = e ? Symbol.for("react.context") : 60110,
    m = e ? Symbol.for("react.async_mode") : 60111,
    f = e ? Symbol.for("react.concurrent_mode") : 60111,
    s = e ? Symbol.for("react.forward_ref") : 60112,
    E = e ? Symbol.for("react.suspense") : 60113,
    c = e ? Symbol.for("react.suspense_list") : 60120,
    x = e ? Symbol.for("react.memo") : 60115,
    F = e ? Symbol.for("react.lazy") : 60116,
    _ = e ? Symbol.for("react.block") : 60121,
    u = e ? Symbol.for("react.fundamental") : 60117,
    v = e ? Symbol.for("react.responder") : 60118,
    y = e ? Symbol.for("react.scope") : 60119;
  function M(h) {
    if (typeof h == "object" && h !== null) {
      var j = h.$$typeof;
      switch (j) {
        case t:
          switch (h = h.type, h) {
            case m:
            case f:
            case n:
            case o:
            case a:
            case E:
              return h;
            default:
              switch (h = h && h.$$typeof, h) {
                case d:
                case s:
                case F:
                case x:
                case i:
                  return h;
                default:
                  return j;
              }
          }
        case r:
          return j;
      }
    }
  }
  function D(h) {
    return M(h) === f;
  }
  return L.AsyncMode = m, L.ConcurrentMode = f, L.ContextConsumer = d, L.ContextProvider = i, L.Element = t, L.ForwardRef = s, L.Fragment = n, L.Lazy = F, L.Memo = x, L.Portal = r, L.Profiler = o, L.StrictMode = a, L.Suspense = E, L.isAsyncMode = function (h) {
    return D(h) || M(h) === m;
  }, L.isConcurrentMode = D, L.isContextConsumer = function (h) {
    return M(h) === d;
  }, L.isContextProvider = function (h) {
    return M(h) === i;
  }, L.isElement = function (h) {
    return typeof h == "object" && h !== null && h.$$typeof === t;
  }, L.isForwardRef = function (h) {
    return M(h) === s;
  }, L.isFragment = function (h) {
    return M(h) === n;
  }, L.isLazy = function (h) {
    return M(h) === F;
  }, L.isMemo = function (h) {
    return M(h) === x;
  }, L.isPortal = function (h) {
    return M(h) === r;
  }, L.isProfiler = function (h) {
    return M(h) === o;
  }, L.isStrictMode = function (h) {
    return M(h) === a;
  }, L.isSuspense = function (h) {
    return M(h) === E;
  }, L.isValidElementType = function (h) {
    return typeof h == "string" || typeof h == "function" || h === n || h === f || h === o || h === a || h === E || h === c || typeof h == "object" && h !== null && (h.$$typeof === F || h.$$typeof === x || h.$$typeof === i || h.$$typeof === d || h.$$typeof === s || h.$$typeof === u || h.$$typeof === v || h.$$typeof === y || h.$$typeof === _);
  }, L.typeOf = M, L;
}
var G = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hr;
function _c() {
  return hr || (hr = 1, process.env.NODE_ENV !== "production" && function () {
    var e = typeof Symbol == "function" && Symbol.for,
      t = e ? Symbol.for("react.element") : 60103,
      r = e ? Symbol.for("react.portal") : 60106,
      n = e ? Symbol.for("react.fragment") : 60107,
      a = e ? Symbol.for("react.strict_mode") : 60108,
      o = e ? Symbol.for("react.profiler") : 60114,
      i = e ? Symbol.for("react.provider") : 60109,
      d = e ? Symbol.for("react.context") : 60110,
      m = e ? Symbol.for("react.async_mode") : 60111,
      f = e ? Symbol.for("react.concurrent_mode") : 60111,
      s = e ? Symbol.for("react.forward_ref") : 60112,
      E = e ? Symbol.for("react.suspense") : 60113,
      c = e ? Symbol.for("react.suspense_list") : 60120,
      x = e ? Symbol.for("react.memo") : 60115,
      F = e ? Symbol.for("react.lazy") : 60116,
      _ = e ? Symbol.for("react.block") : 60121,
      u = e ? Symbol.for("react.fundamental") : 60117,
      v = e ? Symbol.for("react.responder") : 60118,
      y = e ? Symbol.for("react.scope") : 60119;
    function M(g) {
      return typeof g == "string" || typeof g == "function" ||
      // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      g === n || g === f || g === o || g === a || g === E || g === c || typeof g == "object" && g !== null && (g.$$typeof === F || g.$$typeof === x || g.$$typeof === i || g.$$typeof === d || g.$$typeof === s || g.$$typeof === u || g.$$typeof === v || g.$$typeof === y || g.$$typeof === _);
    }
    function D(g) {
      if (typeof g == "object" && g !== null) {
        var H = g.$$typeof;
        switch (H) {
          case t:
            var w = g.type;
            switch (w) {
              case m:
              case f:
              case n:
              case o:
              case a:
              case E:
                return w;
              default:
                var O = w && w.$$typeof;
                switch (O) {
                  case d:
                  case s:
                  case F:
                  case x:
                  case i:
                    return O;
                  default:
                    return H;
                }
            }
          case r:
            return H;
        }
      }
    }
    var h = m,
      j = f,
      ae = d,
      q = i,
      te = t,
      oe = s,
      le = n,
      Z = F,
      J = x,
      re = r,
      V = o,
      pe = a,
      ee = E,
      X = !1;
    function fe(g) {
      return X || (X = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ue(g) || D(g) === m;
    }
    function ue(g) {
      return D(g) === f;
    }
    function he(g) {
      return D(g) === d;
    }
    function T(g) {
      return D(g) === i;
    }
    function b(g) {
      return typeof g == "object" && g !== null && g.$$typeof === t;
    }
    function A(g) {
      return D(g) === s;
    }
    function C(g) {
      return D(g) === n;
    }
    function l(g) {
      return D(g) === F;
    }
    function N(g) {
      return D(g) === x;
    }
    function S(g) {
      return D(g) === r;
    }
    function $(g) {
      return D(g) === o;
    }
    function B(g) {
      return D(g) === a;
    }
    function k(g) {
      return D(g) === E;
    }
    G.AsyncMode = h, G.ConcurrentMode = j, G.ContextConsumer = ae, G.ContextProvider = q, G.Element = te, G.ForwardRef = oe, G.Fragment = le, G.Lazy = Z, G.Memo = J, G.Portal = re, G.Profiler = V, G.StrictMode = pe, G.Suspense = ee, G.isAsyncMode = fe, G.isConcurrentMode = ue, G.isContextConsumer = he, G.isContextProvider = T, G.isElement = b, G.isForwardRef = A, G.isFragment = C, G.isLazy = l, G.isMemo = N, G.isPortal = S, G.isProfiler = $, G.isStrictMode = B, G.isSuspense = k, G.isValidElementType = M, G.typeOf = D;
  }()), G;
}
process.env.NODE_ENV === "production" ? bt.exports = Dc() : bt.exports = _c();
var Fc = bt.exports,
  Gt = Fc,
  Mc = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  },
  Cc = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  },
  Ic = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  },
  En = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  },
  $t = {};
$t[Gt.ForwardRef] = Ic;
$t[Gt.Memo] = En;
function mr(e) {
  return Gt.isMemo(e) ? En : $t[e.$$typeof] || Mc;
}
var Oc = Object.defineProperty,
  kc = Object.getOwnPropertyNames,
  gr = Object.getOwnPropertySymbols,
  xc = Object.getOwnPropertyDescriptor,
  Nc = Object.getPrototypeOf,
  Sr = Object.prototype;
function Tn(e, t, r) {
  if (typeof t != "string") {
    if (Sr) {
      var n = Nc(t);
      n && n !== Sr && Tn(e, n, r);
    }
    var a = kc(t);
    gr && (a = a.concat(gr(t)));
    for (var o = mr(e), i = mr(t), d = 0; d < a.length; ++d) {
      var m = a[d];
      if (!Cc[m] && !(r && r[m]) && !(i && i[m]) && !(o && o[m])) {
        var f = xc(t, m);
        try {
          Oc(e, m, f);
        } catch {}
      }
    }
  }
  return e;
}
var Bc = Tn;
const Rc = /* @__PURE__ */Bn(Bc);
function me() {
  return (me = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }).apply(this, arguments);
}
var yr = function (e, t) {
    for (var r = [e[0]], n = 0, a = t.length; n < a; n += 1) r.push(t[n], e[n + 1]);
    return r;
  },
  At = function (e) {
    return e !== null && typeof e == "object" && (e.toString ? e.toString() : Object.prototype.toString.call(e)) === "[object Object]" && !Lt.typeOf(e);
  },
  et = Object.freeze([]),
  Ae = Object.freeze({});
function $e(e) {
  return typeof e == "function";
}
function Et(e) {
  return process.env.NODE_ENV !== "production" && typeof e == "string" && e || e.displayName || e.name || "Component";
}
function Ht(e) {
  return e && typeof e.styledComponentId == "string";
}
var Ie = typeof process < "u" && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled",
  Ut = typeof window < "u" && "HTMLElement" in window,
  Pc = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process < "u" && process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : typeof process < "u" && process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production"),
  Yc = process.env.NODE_ENV !== "production" ? {
    1: `Cannot create styled-component for component: %s.

`,
    2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`,
    3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`,
    4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`,
    5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`,
    6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`,
    7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',
    8: `ThemeProvider: Please make your "theme" prop an object.

`,
    9: "Missing document `<head>`\n\n",
    10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`,
    11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`,
    12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
    13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`,
    14: `ThemeProvider: "theme" prop is required.

`,
    15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",
    16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`,
    17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
`
  } : {};
function Lc() {
  for (var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], r = 1, n = arguments.length; r < n; r += 1) t.push(r < 0 || arguments.length <= r ? void 0 : arguments[r]);
  return t.forEach(function (a) {
    e = e.replace(/%[a-z]/, a);
  }), e;
}
function ke(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) r[n - 1] = arguments[n];
  throw process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (r.length > 0 ? " Args: " + r.join(", ") : "")) : new Error(Lc.apply(void 0, [Yc[e]].concat(r)).trim());
}
var Gc = function () {
    function e(r) {
      this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = r;
    }
    var t = e.prototype;
    return t.indexOfGroup = function (r) {
      for (var n = 0, a = 0; a < r; a++) n += this.groupSizes[a];
      return n;
    }, t.insertRules = function (r, n) {
      if (r >= this.groupSizes.length) {
        for (var a = this.groupSizes, o = a.length, i = o; r >= i;) (i <<= 1) < 0 && ke(16, "" + r);
        this.groupSizes = new Uint32Array(i), this.groupSizes.set(a), this.length = i;
        for (var d = o; d < i; d++) this.groupSizes[d] = 0;
      }
      for (var m = this.indexOfGroup(r + 1), f = 0, s = n.length; f < s; f++) this.tag.insertRule(m, n[f]) && (this.groupSizes[r]++, m++);
    }, t.clearGroup = function (r) {
      if (r < this.length) {
        var n = this.groupSizes[r],
          a = this.indexOfGroup(r),
          o = a + n;
        this.groupSizes[r] = 0;
        for (var i = a; i < o; i++) this.tag.deleteRule(a);
      }
    }, t.getGroup = function (r) {
      var n = "";
      if (r >= this.length || this.groupSizes[r] === 0) return n;
      for (var a = this.groupSizes[r], o = this.indexOfGroup(r), i = o + a, d = o; d < i; d++) n += this.tag.getRule(d) + `/*!sc*/
`;
      return n;
    }, e;
  }(),
  Xe = /* @__PURE__ */new Map(),
  tt = /* @__PURE__ */new Map(),
  Be = 1,
  ze = function (e) {
    if (Xe.has(e)) return Xe.get(e);
    for (; tt.has(Be);) Be++;
    var t = Be++;
    return process.env.NODE_ENV !== "production" && ((0 | t) < 0 || t > 1 << 30) && ke(16, "" + t), Xe.set(e, t), tt.set(t, e), t;
  },
  $c = function (e) {
    return tt.get(e);
  },
  Hc = function (e, t) {
    t >= Be && (Be = t + 1), Xe.set(e, t), tt.set(t, e);
  },
  Uc = "style[" + Ie + '][data-styled-version="5.3.6"]',
  Wc = new RegExp("^" + Ie + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),
  zc = function (e, t, r) {
    for (var n, a = r.split(","), o = 0, i = a.length; o < i; o++) (n = a[o]) && e.registerName(t, n);
  },
  jc = function (e, t) {
    for (var r = (t.textContent || "").split(`/*!sc*/
`), n = [], a = 0, o = r.length; a < o; a++) {
      var i = r[a].trim();
      if (i) {
        var d = i.match(Wc);
        if (d) {
          var m = 0 | parseInt(d[1], 10),
            f = d[2];
          m !== 0 && (Hc(f, m), zc(e, f, d[3]), e.getTag().insertRules(m, n)), n.length = 0;
        } else n.push(i);
      }
    }
  },
  Vc = function () {
    return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
  },
  Dn = function (e) {
    var t = document.head,
      r = e || t,
      n = document.createElement("style"),
      a = function (d) {
        for (var m = d.childNodes, f = m.length; f >= 0; f--) {
          var s = m[f];
          if (s && s.nodeType === 1 && s.hasAttribute(Ie)) return s;
        }
      }(r),
      o = a !== void 0 ? a.nextSibling : null;
    n.setAttribute(Ie, "active"), n.setAttribute("data-styled-version", "5.3.6");
    var i = Vc();
    return i && n.setAttribute("nonce", i), r.insertBefore(n, o), n;
  },
  Xc = function () {
    function e(r) {
      var n = this.element = Dn(r);
      n.appendChild(document.createTextNode("")), this.sheet = function (a) {
        if (a.sheet) return a.sheet;
        for (var o = document.styleSheets, i = 0, d = o.length; i < d; i++) {
          var m = o[i];
          if (m.ownerNode === a) return m;
        }
        ke(17);
      }(n), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function (r, n) {
      try {
        return this.sheet.insertRule(n, r), this.length++, !0;
      } catch {
        return !1;
      }
    }, t.deleteRule = function (r) {
      this.sheet.deleteRule(r), this.length--;
    }, t.getRule = function (r) {
      var n = this.sheet.cssRules[r];
      return n !== void 0 && typeof n.cssText == "string" ? n.cssText : "";
    }, e;
  }(),
  Zc = function () {
    function e(r) {
      var n = this.element = Dn(r);
      this.nodes = n.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function (r, n) {
      if (r <= this.length && r >= 0) {
        var a = document.createTextNode(n),
          o = this.nodes[r];
        return this.element.insertBefore(a, o || null), this.length++, !0;
      }
      return !1;
    }, t.deleteRule = function (r) {
      this.element.removeChild(this.nodes[r]), this.length--;
    }, t.getRule = function (r) {
      return r < this.length ? this.nodes[r].textContent : "";
    }, e;
  }(),
  Kc = function () {
    function e(r) {
      this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function (r, n) {
      return r <= this.length && (this.rules.splice(r, 0, n), this.length++, !0);
    }, t.deleteRule = function (r) {
      this.rules.splice(r, 1), this.length--;
    }, t.getRule = function (r) {
      return r < this.length ? this.rules[r] : "";
    }, e;
  }(),
  vr = Ut,
  Qc = {
    isServer: !Ut,
    useCSSOMInjection: !Pc
  },
  _n = function () {
    function e(r, n, a) {
      r === void 0 && (r = Ae), n === void 0 && (n = {}), this.options = me({}, Qc, {}, r), this.gs = n, this.names = new Map(a), this.server = !!r.isServer, !this.server && Ut && vr && (vr = !1, function (o) {
        for (var i = document.querySelectorAll(Uc), d = 0, m = i.length; d < m; d++) {
          var f = i[d];
          f && f.getAttribute(Ie) !== "active" && (jc(o, f), f.parentNode && f.parentNode.removeChild(f));
        }
      }(this));
    }
    e.registerId = function (r) {
      return ze(r);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function (r, n) {
      return n === void 0 && (n = !0), new e(me({}, this.options, {}, r), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function (r) {
      return this.gs[r] = (this.gs[r] || 0) + 1;
    }, t.getTag = function () {
      return this.tag || (this.tag = (a = (n = this.options).isServer, o = n.useCSSOMInjection, i = n.target, r = a ? new Kc(i) : o ? new Xc(i) : new Zc(i), new Gc(r)));
      var r, n, a, o, i;
    }, t.hasNameForId = function (r, n) {
      return this.names.has(r) && this.names.get(r).has(n);
    }, t.registerName = function (r, n) {
      if (ze(r), this.names.has(r)) this.names.get(r).add(n);else {
        var a = /* @__PURE__ */new Set();
        a.add(n), this.names.set(r, a);
      }
    }, t.insertRules = function (r, n, a) {
      this.registerName(r, n), this.getTag().insertRules(ze(r), a);
    }, t.clearNames = function (r) {
      this.names.has(r) && this.names.get(r).clear();
    }, t.clearRules = function (r) {
      this.getTag().clearGroup(ze(r)), this.clearNames(r);
    }, t.clearTag = function () {
      this.tag = void 0;
    }, t.toString = function () {
      return function (r) {
        for (var n = r.getTag(), a = n.length, o = "", i = 0; i < a; i++) {
          var d = $c(i);
          if (d !== void 0) {
            var m = r.names.get(d),
              f = n.getGroup(i);
            if (m && f && m.size) {
              var s = Ie + ".g" + i + '[id="' + d + '"]',
                E = "";
              m !== void 0 && m.forEach(function (c) {
                c.length > 0 && (E += c + ",");
              }), o += "" + f + s + '{content:"' + E + `"}/*!sc*/
`;
            }
          }
        }
        return o;
      }(this);
    }, e;
  }(),
  qc = /(a)(d)/gi,
  wr = function (e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
  };
function Tt(e) {
  var t,
    r = "";
  for (t = Math.abs(e); t > 52; t = t / 52 | 0) r = wr(t % 52) + r;
  return (wr(t % 52) + r).replace(qc, "$1-$2");
}
var Te = function (e, t) {
    for (var r = t.length; r;) e = 33 * e ^ t.charCodeAt(--r);
    return e;
  },
  Fn = function (e) {
    return Te(5381, e);
  };
function Jc(e) {
  for (var t = 0; t < e.length; t += 1) {
    var r = e[t];
    if ($e(r) && !Ht(r)) return !1;
  }
  return !0;
}
var e0 = Fn("5.3.6"),
  t0 = function () {
    function e(t, r, n) {
      this.rules = t, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (n === void 0 || n.isStatic) && Jc(t), this.componentId = r, this.baseHash = Te(e0, r), this.baseStyle = n, _n.registerId(r);
    }
    return e.prototype.generateAndInjectStyles = function (t, r, n) {
      var a = this.componentId,
        o = [];
      if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(t, r, n)), this.isStatic && !n.hash) {
        if (this.staticRulesId && r.hasNameForId(a, this.staticRulesId)) o.push(this.staticRulesId);else {
          var i = Oe(this.rules, t, r, n).join(""),
            d = Tt(Te(this.baseHash, i) >>> 0);
          if (!r.hasNameForId(a, d)) {
            var m = n(i, "." + d, void 0, a);
            r.insertRules(a, d, m);
          }
          o.push(d), this.staticRulesId = d;
        }
      } else {
        for (var f = this.rules.length, s = Te(this.baseHash, n.hash), E = "", c = 0; c < f; c++) {
          var x = this.rules[c];
          if (typeof x == "string") E += x, process.env.NODE_ENV !== "production" && (s = Te(s, x + c));else if (x) {
            var F = Oe(x, t, r, n),
              _ = Array.isArray(F) ? F.join("") : F;
            s = Te(s, _ + c), E += _;
          }
        }
        if (E) {
          var u = Tt(s >>> 0);
          if (!r.hasNameForId(a, u)) {
            var v = n(E, "." + u, void 0, a);
            r.insertRules(a, u, v);
          }
          o.push(u);
        }
      }
      return o.join(" ");
    }, e;
  }(),
  r0 = /^\s*\/\/.*$/gm,
  n0 = [":", "[", ".", "#"];
function a0(e) {
  var t,
    r,
    n,
    a,
    o = e === void 0 ? Ae : e,
    i = o.options,
    d = i === void 0 ? Ae : i,
    m = o.plugins,
    f = m === void 0 ? et : m,
    s = new bc(d),
    E = [],
    c = /* @__PURE__ */function (_) {
      function u(v) {
        if (v) try {
          _(v + "}");
        } catch {}
      }
      return function (v, y, M, D, h, j, ae, q, te, oe) {
        switch (v) {
          case 1:
            if (te === 0 && y.charCodeAt(0) === 64) return _(y + ";"), "";
            break;
          case 2:
            if (q === 0) return y + "/*|*/";
            break;
          case 3:
            switch (q) {
              case 102:
              case 112:
                return _(M[0] + y), "";
              default:
                return y + (oe === 0 ? "/*|*/" : "");
            }
          case -2:
            y.split("/*|*/}").forEach(u);
        }
      };
    }(function (_) {
      E.push(_);
    }),
    x = function (_, u, v) {
      return u === 0 && n0.indexOf(v[r.length]) !== -1 || v.match(a) ? _ : "." + t;
    };
  function F(_, u, v, y) {
    y === void 0 && (y = "&");
    var M = _.replace(r0, ""),
      D = u && v ? v + " " + u + " { " + M + " }" : M;
    return t = y, r = u, n = new RegExp("\\" + r + "\\b", "g"), a = new RegExp("(\\" + r + "\\b){2,}"), s(v || !u ? "" : u, D);
  }
  return s.use([].concat(f, [function (_, u, v) {
    _ === 2 && v.length && v[0].lastIndexOf(r) > 0 && (v[0] = v[0].replace(n, x));
  }, c, function (_) {
    if (_ === -2) {
      var u = E;
      return E = [], u;
    }
  }])), F.hash = f.length ? f.reduce(function (_, u) {
    return u.name || ke(15), Te(_, u.name);
  }, 5381).toString() : "", F;
}
var Mn = rt.createContext();
Mn.Consumer;
var Cn = rt.createContext(),
  o0 = (Cn.Consumer, new _n()),
  Dt = a0();
function s0() {
  return Ft(Mn) || o0;
}
function i0() {
  return Ft(Cn) || Dt;
}
var u0 = function () {
    function e(t, r) {
      var n = this;
      this.inject = function (a, o) {
        o === void 0 && (o = Dt);
        var i = n.name + o.hash;
        a.hasNameForId(n.id, i) || a.insertRules(n.id, i, o(n.rules, i, "@keyframes"));
      }, this.toString = function () {
        return ke(12, String(n.name));
      }, this.name = t, this.id = "sc-keyframes-" + t, this.rules = r;
    }
    return e.prototype.getName = function (t) {
      return t === void 0 && (t = Dt), this.name + t.hash;
    }, e;
  }(),
  c0 = /([A-Z])/,
  l0 = /([A-Z])/g,
  f0 = /^ms-/,
  d0 = function (e) {
    return "-" + e.toLowerCase();
  };
function br(e) {
  return c0.test(e) ? e.replace(l0, d0).replace(f0, "-ms-") : e;
}
var Ar = function (e) {
  return e == null || e === !1 || e === "";
};
function Oe(e, t, r, n) {
  if (Array.isArray(e)) {
    for (var a, o = [], i = 0, d = e.length; i < d; i += 1) (a = Oe(e[i], t, r, n)) !== "" && (Array.isArray(a) ? o.push.apply(o, a) : o.push(a));
    return o;
  }
  if (Ar(e)) return "";
  if (Ht(e)) return "." + e.styledComponentId;
  if ($e(e)) {
    if (typeof (f = e) != "function" || f.prototype && f.prototype.isReactComponent || !t) return e;
    var m = e(t);
    return process.env.NODE_ENV !== "production" && Lt.isElement(m) && console.warn(Et(e) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), Oe(m, t, r, n);
  }
  var f;
  return e instanceof u0 ? r ? (e.inject(r, n), e.getName(n)) : e : At(e) ? function s(E, c) {
    var x,
      F,
      _ = [];
    for (var u in E) E.hasOwnProperty(u) && !Ar(E[u]) && (Array.isArray(E[u]) && E[u].isCss || $e(E[u]) ? _.push(br(u) + ":", E[u], ";") : At(E[u]) ? _.push.apply(_, s(E[u], u)) : _.push(br(u) + ": " + (x = u, (F = E[u]) == null || typeof F == "boolean" || F === "" ? "" : typeof F != "number" || F === 0 || x in Ac ? String(F).trim() : F + "px") + ";"));
    return c ? [c + " {"].concat(_, ["}"]) : _;
  }(e) : e.toString();
}
var Er = function (e) {
  return Array.isArray(e) && (e.isCss = !0), e;
};
function p0(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) r[n - 1] = arguments[n];
  return $e(e) || At(e) ? Er(Oe(yr(et, [e].concat(r)))) : r.length === 0 && e.length === 1 && typeof e[0] == "string" ? e : Er(Oe(yr(e, r)));
}
var Tr = /invalid hook call/i,
  je = /* @__PURE__ */new Set(),
  h0 = function (e, t) {
    if (process.env.NODE_ENV !== "production") {
      var r = "The component " + e + (t ? ' with the id of "' + t + '"' : "") + ` has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`,
        n = console.error;
      try {
        var a = !0;
        console.error = function (o) {
          if (Tr.test(o)) a = !1, je.delete(r);else {
            for (var i = arguments.length, d = new Array(i > 1 ? i - 1 : 0), m = 1; m < i; m++) d[m - 1] = arguments[m];
            n.apply(void 0, [o].concat(d));
          }
        }, xn(), a && !je.has(r) && (console.warn(r), je.add(r));
      } catch (o) {
        Tr.test(o.message) && je.delete(r);
      } finally {
        console.error = n;
      }
    }
  },
  m0 = function (e, t, r) {
    return r === void 0 && (r = Ae), e.theme !== r.theme && e.theme || t || r.theme;
  },
  g0 = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,
  S0 = /(^-|-$)/g;
function ft(e) {
  return e.replace(g0, "-").replace(S0, "");
}
var y0 = function (e) {
  return Tt(Fn(e) >>> 0);
};
function Ve(e) {
  return typeof e == "string" && (process.env.NODE_ENV === "production" || e.charAt(0) === e.charAt(0).toLowerCase());
}
var _t = function (e) {
    return typeof e == "function" || typeof e == "object" && e !== null && !Array.isArray(e);
  },
  v0 = function (e) {
    return e !== "__proto__" && e !== "constructor" && e !== "prototype";
  };
function w0(e, t, r) {
  var n = e[r];
  _t(t) && _t(n) ? In(n, t) : e[r] = t;
}
function In(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) r[n - 1] = arguments[n];
  for (var a = 0, o = r; a < o.length; a++) {
    var i = o[a];
    if (_t(i)) for (var d in i) v0(d) && w0(e, i[d], d);
  }
  return e;
}
var On = rt.createContext();
On.Consumer;
var dt = {};
function kn(e, t, r) {
  var n = Ht(e),
    a = !Ve(e),
    o = t.attrs,
    i = o === void 0 ? et : o,
    d = t.componentId,
    m = d === void 0 ? function (y, M) {
      var D = typeof y != "string" ? "sc" : ft(y);
      dt[D] = (dt[D] || 0) + 1;
      var h = D + "-" + y0("5.3.6" + D + dt[D]);
      return M ? M + "-" + h : h;
    }(t.displayName, t.parentComponentId) : d,
    f = t.displayName,
    s = f === void 0 ? function (y) {
      return Ve(y) ? "styled." + y : "Styled(" + Et(y) + ")";
    }(e) : f,
    E = t.displayName && t.componentId ? ft(t.displayName) + "-" + t.componentId : t.componentId || m,
    c = n && e.attrs ? Array.prototype.concat(e.attrs, i).filter(Boolean) : i,
    x = t.shouldForwardProp;
  n && e.shouldForwardProp && (x = t.shouldForwardProp ? function (y, M, D) {
    return e.shouldForwardProp(y, M, D) && t.shouldForwardProp(y, M, D);
  } : e.shouldForwardProp);
  var F,
    _ = new t0(r, E, n ? e.componentStyle : void 0),
    u = _.isStatic && i.length === 0,
    v = function (y, M) {
      return function (D, h, j, ae) {
        var q = D.attrs,
          te = D.componentStyle,
          oe = D.defaultProps,
          le = D.foldedComponentIds,
          Z = D.shouldForwardProp,
          J = D.styledComponentId,
          re = D.target;
        process.env.NODE_ENV !== "production" && Wt(J);
        var V = function (C, l, N) {
            C === void 0 && (C = Ae);
            var S = me({}, l, {
                theme: C
              }),
              $ = {};
            return N.forEach(function (B) {
              var k,
                g,
                H,
                w = B;
              for (k in $e(w) && (w = w(S)), w) S[k] = $[k] = k === "className" ? (g = $[k], H = w[k], g && H ? g + " " + H : g || H) : w[k];
            }), [S, $];
          }(m0(h, Ft(On), oe) || Ae, h, q),
          pe = V[0],
          ee = V[1],
          X = function (C, l, N, S) {
            var $ = s0(),
              B = i0(),
              k = l ? C.generateAndInjectStyles(Ae, $, B) : C.generateAndInjectStyles(N, $, B);
            return process.env.NODE_ENV !== "production" && Wt(k), process.env.NODE_ENV !== "production" && !l && S && S(k), k;
          }(te, ae, pe, process.env.NODE_ENV !== "production" ? D.warnTooManyClasses : void 0),
          fe = j,
          ue = ee.$as || h.$as || ee.as || h.as || re,
          he = Ve(ue),
          T = ee !== h ? me({}, h, {}, ee) : h,
          b = {};
        for (var A in T) A[0] !== "$" && A !== "as" && (A === "forwardedAs" ? b.as = T[A] : (Z ? Z(A, dr, ue) : !he || dr(A)) && (b[A] = T[A]));
        return h.style && ee.style !== h.style && (b.style = me({}, h.style, {}, ee.style)), b.className = Array.prototype.concat(le, J, X !== J ? X : null, h.className, ee.className).filter(Boolean).join(" "), b.ref = fe, Nn(ue, b);
      }(F, y, M, u);
    };
  return v.displayName = s, (F = rt.forwardRef(v)).attrs = c, F.componentStyle = _, F.displayName = s, F.shouldForwardProp = x, F.foldedComponentIds = n ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : et, F.styledComponentId = E, F.target = n ? e.target : e, F.withComponent = function (y) {
    var M = t.componentId,
      D = function (j, ae) {
        if (j == null) return {};
        var q,
          te,
          oe = {},
          le = Object.keys(j);
        for (te = 0; te < le.length; te++) q = le[te], ae.indexOf(q) >= 0 || (oe[q] = j[q]);
        return oe;
      }(t, ["componentId"]),
      h = M && M + "-" + (Ve(y) ? y : ft(Et(y)));
    return kn(y, me({}, D, {
      attrs: c,
      componentId: h
    }), r);
  }, Object.defineProperty(F, "defaultProps", {
    get: function () {
      return this._foldedDefaultProps;
    },
    set: function (y) {
      this._foldedDefaultProps = n ? In({}, e.defaultProps, y) : y;
    }
  }), process.env.NODE_ENV !== "production" && (h0(s, E), F.warnTooManyClasses = /* @__PURE__ */function (y, M) {
    var D = {},
      h = !1;
    return function (j) {
      if (!h && (D[j] = !0, Object.keys(D).length >= 200)) {
        var ae = M ? ' with the id of "' + M + '"' : "";
        console.warn("Over 200 classes were generated for component " + y + ae + `.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), h = !0, D = {};
      }
    };
  }(s, E)), F.toString = function () {
    return "." + F.styledComponentId;
  }, a && Rc(F, e, {
    attrs: !0,
    componentStyle: !0,
    displayName: !0,
    foldedComponentIds: !0,
    shouldForwardProp: !0,
    styledComponentId: !0,
    target: !0,
    withComponent: !0
  }), F;
}
var De = function (e) {
  return function t(r, n, a) {
    if (a === void 0 && (a = Ae), !Lt.isValidElementType(n)) return ke(1, String(n));
    var o = function () {
      return r(n, a, p0.apply(void 0, arguments));
    };
    return o.withConfig = function (i) {
      return t(r, n, me({}, a, {}, i));
    }, o.attrs = function (i) {
      return t(r, n, me({}, a, {
        attrs: Array.prototype.concat(a.attrs, i).filter(Boolean)
      }));
    }, o;
  }(kn, e);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function (e) {
  De[e] = De(e);
});
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`), process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, window["__styled-components-init__"] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window["__styled-components-init__"] += 1);
const b0 = De.div`
  display: flex;
  align-items: center;
  height: 4rem;
  overflow: hidden;
`,
  A0 = De.div`
  display: flex;
  align-items: center;
  font-family: 'Averta';
  font-size: 1.4rem;
  color: ${Fe.White};
  animation: slideUp ${Yt}ms cubic-bezier(.33,0,.38,1) forwards;

  @keyframes slideUp {
    0% {
      opacity: 0;
      transform: translateY(120%);
    }

    10% {
      opacity: 1;
      transform: translateY(0);
    }

    90% {
      opacity: 1;
      transform: translateY(0);
    }

    100% {
      opacity: 0;
      transform: translateY(-120%);
    }
  }
`,
  E0 = De.span`
  font-family: 'Averta SemiBold';
`,
  T0 = De.span`
  margin: 0 0.8rem 0 1.6rem;
`,
  D0 = De.span`
  display: flex;
  align-items: center;
  margin-left: 8px;
  color: ${_ref2 => {
    let {
      color: e
    } = _ref2;
    return e || Fe.White;
  }};
  gap: 6px;
`,
  _0 = _ref3 => {
    let {
      size: e
    } = _ref3;
    return /* @__PURE__ */Ze("svg", {
      width: e || "16",
      height: e || "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/* @__PURE__ */z("g", {
        clipPath: "url(#clip0_4503_71875)",
        children: /* @__PURE__ */z("path", {
          d: "M14.76 11.32V1M14.76 1H4.44M14.76 1L1 14.76",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      }), /* @__PURE__ */z("defs", {
        children: /* @__PURE__ */z("clipPath", {
          id: "clip0_4503_71875",
          children: /* @__PURE__ */z("rect", {
            width: "16",
            height: "16",
            fill: "white"
          })
        })
      })]
    });
  },
  F0 = _ref4 => {
    let {
      size: e
    } = _ref4;
    return /* @__PURE__ */Ze("svg", {
      width: e || "16",
      height: e || "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/* @__PURE__ */z("g", {
        clipPath: "url(#clip0_4503_71876)",
        children: /* @__PURE__ */z("path", {
          d: "M4.44 14.76H14.76M14.76 14.76V4.44M14.76 14.76L1 1",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      }), /* @__PURE__ */z("defs", {
        children: /* @__PURE__ */z("clipPath", {
          id: "clip0_4503_71876",
          children: /* @__PURE__ */z("rect", {
            width: "16",
            height: "16",
            fill: "white"
          })
        })
      })]
    });
  },
  M0 = _ref5 => {
    let {
      size: e
    } = _ref5;
    return /* @__PURE__ */z("svg", {
      width: e || "16",
      height: e || "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */z("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.46971 7H14.1703C14.496 7 14.76 7.26402 14.76 7.58971C14.76 7.9154 14.496 8.17943 14.1703 8.17943H8.46971H7.29029H1.58971C1.26402 8.17943 1 7.9154 1 7.58971C1 7.26402 1.26402 7 1.58971 7H7.29029H8.46971Z",
        fill: "currentColor"
      })
    });
  },
  C0 = e => {
    const {
      variationSign: t
    } = e;
    switch (t) {
      case se.positive:
        return /* @__PURE__ */z(_0, {
          size: "10"
        });
      case se.negative:
        return /* @__PURE__ */z(F0, {
          size: "10"
        });
      case se.equal:
      default:
        return /* @__PURE__ */z(M0, {
          size: "14"
        });
    }
  },
  {
    number: Dr
  } = Mr,
  k0 = () => {
    const [e, t] = _r(0),
      r = gc();
    if (Fr(() => {
      if (!r.length) return;
      const x = setInterval(() => {
        t(F => (F + 1) % r.length);
      }, Yt);
      return t(0), () => clearInterval(x);
    }, [r]), !r.length) return null;
    const {
        name: n,
        lastPrice: a,
        variation: o,
        open: i
      } = r[e],
      m = Dr(a, n === An ? 4 : void 0),
      f = Dr(o),
      s = Sc(o),
      E = yc(s, i),
      c = s === se.positive ? "+" : "";
    return /* @__PURE__ */z(b0, {
      "aria-hidden": "true",
      children: /* @__PURE__ */Ze(A0, {
        children: [/* @__PURE__ */z(E0, {
          children: n
        }), /* @__PURE__ */z(T0, {
          children: m
        }), /* @__PURE__ */Ze(D0, {
          color: E,
          children: [`${c}${f}%`, s !== se.equal && /* @__PURE__ */z(C0, {
            variationSign: s
          })]
        })]
      }, n)
    });
  };
export { k0 as default };